(function() {
  function initMultiGoalFreeShippingBar() {
    customElements.whenDefined('free-shipping-bar').then(function() {
      var FreeShippingBar = customElements.get('free-shipping-bar');
      if (!FreeShippingBar) return;

      var originalUpdateMessage = FreeShippingBar.prototype._updateMessage;
      FreeShippingBar.prototype._updateMessage = function() {
        var messageElement = this.querySelector("span");
        if (!messageElement) return;

        if (this.hasAttribute("data-multi-goal")) {
          var prefix = this.getAttribute("data-message-prefix") || "Nur noch";
          var goals = [
            { amount: parseFloat(this.getAttribute("data-goal-1-amount")), message: this.getAttribute("data-goal-1-message") },
            { amount: parseFloat(this.getAttribute("data-goal-2-amount")), message: this.getAttribute("data-goal-2-message") },
            { amount: parseFloat(this.getAttribute("data-goal-3-amount")), message: this.getAttribute("data-goal-3-message") },
            { amount: parseFloat(this.getAttribute("data-goal-4-amount")), message: this.getAttribute("data-goal-4-message") }
          ].filter(function(g) { return g.amount > 0; });
          var nextGoal = goals.find(function(g) { return this.totalPrice < g.amount; }.bind(this));

          function accentGratis(str) {
            return (str || "").replace(/GRATIS/gi, "<span class=\"bold text-accent k7-gratis-accent\">$&</span>");
          }

          if (!nextGoal) {
            messageElement.innerHTML = accentGratis(this.getAttribute("reached-message"));
          } else {
            var amountFormatted = this._currencyFormatter.format((nextGoal.amount - this.totalPrice) / 100).replace(/\$/g, "$$$$");
            messageElement.innerHTML = prefix + " <span class=\"bold text-accent\">" + amountFormatted + "</span> " + accentGratis(nextGoal.message || "");
          }
        } else {
          originalUpdateMessage.call(this);
        }
      };

      function refreshAllMultiGoalBars() {
        document.querySelectorAll('free-shipping-bar[data-multi-goal]').forEach(function(el) {
          if (el._updateMessage) el._updateMessage();
        });
      }

      refreshAllMultiGoalBars();
      document.addEventListener('cart:change', function() {
        setTimeout(refreshAllMultiGoalBars, 50);
      });
      document.addEventListener('shopify:section:load', function() {
        setTimeout(refreshAllMultiGoalBars, 100);
      });
    });
  }

  function getSharedQuantityInput(container) {
    var input = container.querySelector('.bk-media-quantity-preset-input');
    if (input) return input;
    var formId = container.getAttribute('data-form-id');
    if (!formId) return null;
    var byId = document.getElementById(formId + '-quantity');
    if (byId) return byId;
    var form = document.getElementById(formId);
    if (form) {
      var named = form.querySelector('[name="quantity"]');
      if (named) return named;
    }
    return document.querySelector('input[name="quantity"][form="' + formId + '"]');
  }

  function bkMediaUpdateQuickAtcFromRow(row) {
    if (!row) return;
    var label = row.getAttribute('data-qty-label') || '';
    if (!label) {
      var amount = row.querySelector('.bk-media-quantity-preset-row__amount');
      if (amount) label = amount.textContent.trim();
    }
    var finalPrice = row.getAttribute('data-total-final') || '';
    var originalPrice = row.getAttribute('data-total-original') || '';
    var hasDiscount = row.getAttribute('data-has-discount') === 'true';

    document.querySelectorAll('.product-quick-add [data-bk-media-quick-atc-qty-label]').forEach(function (el) {
      if (label) el.textContent = label;
    });
    document.querySelectorAll('.product-quick-add [data-bk-media-quick-atc-switcher]').forEach(function (btn) {
      if (!label) return;
      var prefix = btn.getAttribute('aria-label') || '';
      var colon = prefix.indexOf(':');
      var choose = colon > -1 ? prefix.slice(0, colon).trim() : prefix.trim();
      if (choose) btn.setAttribute('aria-label', choose + ': ' + label);
    });
    document.querySelectorAll('.product-quick-add [data-bk-media-quick-atc-price]').forEach(function (wrap) {
      if (!finalPrice) return;
      var saleEl = wrap.querySelector('[data-role="sale"]');
      var compareEl = wrap.querySelector('[data-role="compare"]');
      if (saleEl) {
        saleEl.textContent = finalPrice;
        saleEl.classList.toggle('text-on-sale', hasDiscount);
      }
      if (compareEl) {
        if (hasDiscount && originalPrice) {
          compareEl.textContent = originalPrice;
          compareEl.hidden = false;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
          compareEl.classList.add('hidden');
        }
      }
    });
  }

  function bkMediaSetQuickAtcOpen(host, open) {
    if (!host) return;
    host.classList.toggle('is-variant-open', open);
    var btn = host.querySelector('[data-bk-media-quick-atc-switcher]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var picker = host.querySelector('[data-bk-media-quick-atc-picker]');
    if (picker) picker.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function formatTrialMoney(cents, sample) {
    var numeric = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var match = String(sample || '').match(/(\d[\d.]*)([.,])(\d+)/);
    var dec = match ? match[2] : ',';
    var thou = dec === ',' ? '.' : ',';
    var whole = numeric[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var number = whole + dec + numeric[1];
    if (!match) return number;
    var index = String(sample).indexOf(match[0]);
    return String(sample).slice(0, index) + number + String(sample).slice(index + match[0].length);
  }

  function updateTrialRow(row, qty) {
    if (!row) return qty;
    var max = parseInt(row.getAttribute('data-trial-max'), 10) || 1;
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    if (qty > max) qty = max;
    var unit = parseInt(row.getAttribute('data-base-price'), 10) || 0;
    var cents = unit * qty;
    var formatted = formatTrialMoney(cents, row.getAttribute('data-unit-price-sample') || '');
    var label = qty + ' Riegel';
    row.setAttribute('data-base-quantity', String(qty));
    row.setAttribute('data-qty-label', label);
    row.setAttribute('data-total-cents', String(cents));
    row.setAttribute('data-total-final', formatted);
    row.setAttribute('data-total-original', formatted);
    var amount = row.querySelector('.bk-media-quantity-preset-row__amount');
    if (amount) amount.textContent = label;
    var price = row.querySelector('.bk-media-quantity-preset-row__trial-price');
    if (price) price.textContent = formatted;
    var stepper = row.querySelector('[data-trial-qty-input]');
    if (stepper && String(stepper.value) !== String(qty)) {
      stepper.value = String(qty);
      if (stepper.quantity !== undefined) stepper.quantity = qty;
    }
    var radio = row.querySelector('input[type="radio"]');
    if (radio) radio.value = String(qty);
    return qty;
  }

  function bkMediaSyncQuickAtcFromSelectors() {
    var selected = document.querySelector('.bk-media-quantity-preset-row.is-selected');
    if (selected) bkMediaUpdateQuickAtcFromRow(selected);
  }

  function initQuantityPresetSelectors() {
    document.querySelectorAll('.bk-media-quantity-preset-selector').forEach(function(container) {
      if (container.dataset.bkMediaPresetInit === 'true') return;
      container.dataset.bkMediaPresetInit = 'true';

      container.querySelectorAll('[data-coconut-trial-end]').forEach(function(node) {
        var end = Date.parse(node.getAttribute('data-coconut-trial-end'));
        if (!isNaN(end) && Date.now() >= end) node.hidden = true;
      });

      var input = getSharedQuantityInput(container);
      var rows = container.querySelectorAll('.bk-media-quantity-preset-row');
      var productInfo = container.closest('.product-info');
      var syncedPrice = productInfo ? productInfo.querySelector('[data-qty-synced-price]') : null;
      var totalEls = [];
      var portionBadgeEls = [];
      var savingsBadgeEls = [];
      var localTotal = container.querySelector('[data-qty-total]');
      var localBadge = container.querySelector('[data-qty-portion-badge]');
      var localSavings = container.querySelector('[data-qty-savings-badge]');
      if (syncedPrice) {
        var syncedTotal = syncedPrice.querySelector('[data-qty-total]');
        var syncedBadge = syncedPrice.querySelector('[data-qty-portion-badge]');
        var syncedSavings = syncedPrice.querySelector('[data-qty-savings-badge]');
        if (syncedTotal) totalEls.push(syncedTotal);
        if (syncedBadge) portionBadgeEls.push(syncedBadge);
        if (syncedSavings) savingsBadgeEls.push(syncedSavings);
      }
      if (localTotal) totalEls.push(localTotal);
      if (localBadge) portionBadgeEls.push(localBadge);
      if (localSavings) savingsBadgeEls.push(localSavings);
      var portionLabel = container.getAttribute('data-portion-label') || 'Shake';
      if (!input || !rows.length) return;

      function renderPortionBadge(row) {
        if (!portionBadgeEls.length || !row) return;
        var portionPrice = row.getAttribute('data-portion-price');
        portionBadgeEls.forEach(function(portionBadgeEl) {
          if (!portionPrice) {
            portionBadgeEl.hidden = true;
            return;
          }
          portionBadgeEl.hidden = false;
          var badgeText = portionBadgeEl.querySelector('.bold') || portionBadgeEl;
          badgeText.textContent = portionPrice + ' pro ' + portionLabel;
        });
      }

      function renderSavingsBadge(row) {
        if (!savingsBadgeEls.length || !row) return;
        var hasDiscount = row.getAttribute('data-has-discount') === 'true';
        var discountPct = row.getAttribute('data-discount') || '';
        savingsBadgeEls.forEach(function(savingsBadgeEl) {
          if (!hasDiscount || !discountPct || discountPct === '0') {
            savingsBadgeEl.hidden = true;
            return;
          }
          savingsBadgeEl.hidden = false;
          var template = savingsBadgeEl.getAttribute('data-savings-template') || '';
          savingsBadgeEl.textContent = template.replace(/__SAVINGS__/g, discountPct + '%');
        });
      }

      function renderTotal(row) {
        if (!totalEls.length || !row) return;
        var finalPrice = row.getAttribute('data-total-final');
        var originalPrice = row.getAttribute('data-total-original');
        var hasDiscount = row.getAttribute('data-has-discount') === 'true';
        if (!finalPrice) return;

        var html = '<price-list class="price-list price-list--lg">';
        if (hasDiscount && originalPrice) {
          html += '<sale-price class="text-on-sale text-lg bold"><span class="sr-only">Sale price</span>' + finalPrice + '</sale-price>';
          html += '<compare-at-price class="text-subdued text-lg line-through"><span class="sr-only">Regular price</span>' + originalPrice + '</compare-at-price>';
        } else {
          html += '<sale-price class="text-lg"><span class="sr-only">Sale price</span>' + finalPrice + '</sale-price>';
        }
        html += '</price-list>';
        totalEls.forEach(function(totalEl) {
          totalEl.innerHTML = html;
        });
        renderPortionBadge(row);
        renderSavingsBadge(row);
      }

      function syncSelection() {
        var qty = parseInt(input.value, 10) || 1;
        var trial = container.querySelector('.bk-media-quantity-preset-row--trial');
        var trialMax = trial ? parseInt(trial.getAttribute('data-trial-max'), 10) || 1 : 0;
        var presetMatch = null;
        var checkedPreset = null;
        rows.forEach(function(row) {
          if (row.classList.contains('bk-media-quantity-preset-row--trial')) return;
          var radio = row.querySelector('input[type="radio"]');
          if (!radio || parseInt(radio.value, 10) !== qty) return;
          presetMatch = row;
          if (radio.checked) checkedPreset = row;
        });
        var selectedRow = null;
        if (checkedPreset) {
          selectedRow = checkedPreset;
        } else if (trial && !trial.hidden && qty >= 1 && qty <= trialMax) {
          selectedRow = trial;
          updateTrialRow(trial, qty);
        } else if (presetMatch) {
          selectedRow = presetMatch;
        }
        rows.forEach(function(row) {
          var radio = row.querySelector('input[type="radio"]');
          var matches = row === selectedRow;
          row.classList.toggle('is-selected', matches);
          if (radio) radio.checked = matches;
        });
        if (selectedRow) {
          renderTotal(selectedRow);
          bkMediaUpdateQuickAtcFromRow(selectedRow);
        }
        updateExtraGiftVisibility();
      }

      function selectRow(row) {
        rows.forEach(function(r) { r.classList.remove('is-selected'); });
        row.classList.add('is-selected');
        var radio = row.querySelector('input[type="radio"]');
        var qty = parseInt(radio && radio.value, 10);
        if (row.classList.contains('bk-media-quantity-preset-row--trial')) {
          var stepper = row.querySelector('[data-trial-qty-input]');
          qty = updateTrialRow(row, stepper ? stepper.value : qty);
        }
        if (radio) radio.checked = true;
        rows.forEach(function(r) {
          if (r === row) return;
          var other = r.querySelector('input[type="radio"]');
          if (other) other.checked = false;
        });
        input.value = qty;
        if (input.quantity !== undefined) input.quantity = qty;
        renderTotal(row);
        bkMediaUpdateQuickAtcFromRow(row);
        updateExtraGiftVisibility();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncSelection();

      rows.forEach(function(row) {
        row.addEventListener('click', function(event) {
          if (event.target.closest('quantity-selector')) return;
          selectRow(this);
        });
      });

      var trialRow = container.querySelector('.bk-media-quantity-preset-row--trial');
      var trialInput = trialRow ? trialRow.querySelector('[data-trial-qty-input]') : null;
      if (trialInput) {
        trialInput.addEventListener('change', function(event) {
          event.stopPropagation();
          selectRow(trialRow);
        });
      }

      container.addEventListener('change', function(e) {
        if (e.target.matches('input[type="radio"]')) {
          var row = e.target.closest('.bk-media-quantity-preset-row');
          if (row) selectRow(row);
        }
      });

      input.addEventListener('change', syncSelection);
    });

    bkMediaSyncQuickAtcFromSelectors();
    updateExtraGiftVisibility();
  }

  /* ========================================
     EXTRA GIFT FREE SHIPPING
     ======================================== */

  function getSelectedExtraGiftTotalCents(card) {
    var root = (card && card.closest('.product-info')) || document;
    var row = root.querySelector('.bk-media-quantity-preset-selector:not(.bk-media-quantity-preset-selector--quick-atc) .bk-media-quantity-preset-row.is-selected')
      || root.querySelector('.bk-media-quantity-preset-row.is-selected');
    if (row) {
      var cents = parseInt(row.getAttribute('data-total-cents'), 10);
      if (!isNaN(cents)) return cents;
      var base = parseInt(row.getAttribute('data-base-price'), 10);
      var qty = parseInt(row.getAttribute('data-base-quantity'), 10) || 1;
      var pd = parseInt(row.getAttribute('data-discount'), 10) || 0;
      if (!isNaN(base)) {
        var unitDiscount = Math.floor(base * pd / 100);
        return (base - unitDiscount) * qty;
      }
    }

    var qtyInput = root.querySelector('form[is="product-form"] [name="quantity"], .bk-media-quantity-preset-input, .quantity-selector__input');
    var selectedQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var selector = root.querySelector('.bk-media-quantity-preset-selector[data-variant-price]');
    if (selector) {
      var variantPrice = parseInt(selector.getAttribute('data-variant-price'), 10);
      if (!isNaN(variantPrice)) return variantPrice * selectedQty;
    }
    return null;
  }

  function updateExtraGiftVisibility() {
    if (window.Shopify && window.Shopify.designMode) return;
    var cards = document.querySelectorAll('[data-extra-gift-threshold]');
    if (!cards.length) return;
    cards.forEach(function(card) {
      var threshold = parseInt(card.getAttribute('data-extra-gift-threshold'), 10);
      if (isNaN(threshold) || threshold <= 0) {
        card.hidden = false;
        return;
      }
      var total = getSelectedExtraGiftTotalCents(card);
      if (total === null) return;
      card.hidden = total < threshold;
    });
  }

  document.addEventListener('variant:change', function() {
    setTimeout(updateExtraGiftVisibility, 0);
  });

  document.addEventListener('change', function(e) {
    if (!e.target) return;
    if (e.target.name === 'quantity' || e.target.classList.contains('quantity-selector__input') || e.target.classList.contains('bk-media-quantity-preset-input')) {
      updateExtraGiftVisibility();
    }
  });

  /* ========================================
     EXTRA GIFT FREE SHIPPING END
     ======================================== */

  /* ========================================
     ABO WIDGET
     ======================================== */

  var aboModeByForm = {};

  function formatAboMoney(cents) {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function aboPlanInput(widget) {
    var formId = widget.getAttribute('data-form-id');
    var form = formId && document.getElementById(formId);
    var input = widget.querySelector('[data-abo-selling-plan]');
    if (!input && form) input = form.querySelector('[data-abo-selling-plan]');
    if (input && form && !form.contains(input)) form.appendChild(input);
    return input;
  }

  function applyAboRowDiscount(row, pct) {
    var selector = row.closest('.bk-media-quantity-preset-selector');
    var base = parseInt(row.getAttribute('data-base-price'), 10);
    var qty = parseInt(row.getAttribute('data-base-quantity'), 10) || 1;
    if (isNaN(base)) return;
    var unitDiscount = Math.floor(base * pct / 100);
    var unitFinal = base - unitDiscount;
    var total = unitFinal * qty;
    var unitPer = selector ? (selector.getAttribute('data-unit-per') || '') : '';
    var portions = selector ? (parseInt(selector.getAttribute('data-portions-per-unit'), 10) || 0) : 0;

    row.setAttribute('data-discount', String(pct));
    row.setAttribute('data-has-discount', pct > 0 ? 'true' : 'false');
    row.setAttribute('data-total-cents', String(total));
    row.setAttribute('data-total-final', formatAboMoney(total));
    row.setAttribute('data-total-original', formatAboMoney(base * qty));
    if (portions > 0) row.setAttribute('data-portion-price', formatAboMoney(Math.floor(unitFinal / portions)));

    var unitEl = row.querySelector('.bk-media-quantity-preset-row__unit-price');
    if (unitEl) unitEl.textContent = formatAboMoney(unitFinal) + (unitPer ? '/' + unitPer : '');

    var badge = row.querySelector('.bk-media-quantity-preset-row__discount');
    if (badge) {
      badge.hidden = pct <= 0;
      var bold = badge.querySelector('.bold');
      if (bold) bold.textContent = '-' + pct + '%';
      else badge.textContent = '-' + pct + '%';
    }
  }

  function applyAboDiscounts(widget, mode) {
    var formId = widget.getAttribute('data-form-id');
    var extra = parseInt(widget.getAttribute('data-extra-discount'), 10) || 0;
    if (!formId) return;
    document.querySelectorAll('.bk-media-quantity-preset-selector[data-form-id="' + formId + '"]').forEach(function(selector) {
      selector.querySelectorAll('.bk-media-quantity-preset-row').forEach(function(row) {
        if (row.classList.contains('bk-media-quantity-preset-row--trial')) return;
        var basePct = parseInt(row.getAttribute('data-onetime-discount'), 10);
        if (isNaN(basePct)) basePct = parseInt(row.getAttribute('data-discount'), 10) || 0;
        var pct = mode === 'subscription' ? Math.min(100, basePct + extra) : basePct;
        applyAboRowDiscount(row, pct);
      });
    });
  }

  function syncAboSellingPlan(widget) {
    var input = aboPlanInput(widget);
    if (!input) return;
    var mode = widget.getAttribute('data-purchase');
    var select = widget.querySelector('[data-abo-interval]');
    var value = '';
    if (mode === 'subscription' && select && select.value) value = select.value;
    input.value = value;
    input.disabled = value === '';
  }

  function setAboMode(widget, mode) {
    if (mode !== 'subscription' && mode !== 'onetime') mode = 'subscription';
    if (!widget.querySelector('[data-abo-tab="onetime"]')) mode = 'subscription';
    widget.setAttribute('data-purchase', mode);
    var formId = widget.getAttribute('data-form-id');
    if (formId) aboModeByForm[formId] = mode;
    widget.querySelectorAll('[data-abo-tab]').forEach(function(tab) {
      tab.setAttribute('aria-selected', tab.getAttribute('data-abo-tab') === mode ? 'true' : 'false');
    });
    widget.querySelectorAll('[data-abo-panel]').forEach(function(panel) {
      panel.hidden = panel.getAttribute('data-abo-panel') !== mode;
    });
    widget.querySelectorAll('[data-abo-only]').forEach(function(el) {
      el.hidden = mode !== 'subscription';
    });
    applyAboDiscounts(widget, mode);
    syncAboSellingPlan(widget);
    var selector = widget.querySelector('.bk-media-quantity-preset-selector');
    var qtyInput = selector && getSharedQuantityInput(selector);
    if (qtyInput) qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateExtraGiftVisibility();
  }

  function initAboWidgets() {
    document.querySelectorAll('[data-abo-widget]').forEach(function(widget) {
      var formId = widget.getAttribute('data-form-id');
      var mode = (formId && aboModeByForm[formId]) || widget.getAttribute('data-purchase') || 'subscription';
      setAboMode(widget, mode);
    });
  }

  if (!window.bkMediaAboBound) {
    window.bkMediaAboBound = true;
    document.addEventListener('click', function(event) {
      var tab = event.target.closest && event.target.closest('[data-abo-tab]');
      if (!tab) return;
      var widget = tab.closest('[data-abo-widget]');
      if (!widget) return;
      setAboMode(widget, tab.getAttribute('data-abo-tab'));
    });
    document.addEventListener('change', function(event) {
      if (!event.target.matches || !event.target.matches('[data-abo-interval]')) return;
      var widget = event.target.closest('[data-abo-widget]');
      if (widget) syncAboSellingPlan(widget);
    });
  }

  /* ========================================
     ABO WIDGET END
     ======================================== */

  document.addEventListener('click', function (e) {
    var switcher = e.target.closest('[data-bk-media-quick-atc-switcher]');
    if (switcher) {
      var host = switcher.closest('product-quick-add');
      if (!host) return;
      bkMediaSetQuickAtcOpen(host, !host.classList.contains('is-variant-open'));
      return;
    }

    document.querySelectorAll('product-quick-add.is-variant-open').forEach(function (openHost) {
      if (openHost.contains(e.target) && e.target.closest('[data-bk-media-quick-atc-picker]')) return;
      if (openHost.contains(e.target) && e.target.closest('buy-buttons')) return;
      bkMediaSetQuickAtcOpen(openHost, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('product-quick-add.is-variant-open').forEach(function (host) {
      bkMediaSetQuickAtcOpen(host, false);
    });
  });

  function setupProductRerenderListener() {
    document.querySelectorAll('product-rerender[observe-form]').forEach(function(pr) {
      var formId = pr.getAttribute('observe-form');
      var form = document.getElementById(formId);
      if (form && !form.dataset.bkMediaPresetListener) {
        form.dataset.bkMediaPresetListener = 'true';
        form.addEventListener('product:rerender', function() {
          document.querySelectorAll('.bk-media-quantity-preset-selector').forEach(function(c) {
            delete c.dataset.bkMediaPresetInit;
          });
          setTimeout(function() {
            initQuantityPresetSelectors();
            initAboWidgets();
          }, 0);
        });
      }
    });
  }

  initMultiGoalFreeShippingBar();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initQuantityPresetSelectors();
      initAboWidgets();
      setupProductRerenderListener();
    });
  } else {
    initQuantityPresetSelectors();
    initAboWidgets();
    setupProductRerenderListener();
  }

  document.addEventListener('shopify:section:load', function(evt) {
    setTimeout(function() {
      document.querySelectorAll('.bk-media-quantity-preset-selector').forEach(function(c) {
        delete c.dataset.bkMediaPresetInit;
      });
      initQuantityPresetSelectors();
      initAboWidgets();
      setupProductRerenderListener();
    }, 100);
  });

  function initTimerBlock(timerElement) {
    var daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
    var hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
    var minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
    var secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
    var timerBlock = timerElement.closest('.bk-media-timer-block');
    var progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      console.warn('Timer block elements not found', timerElement);
      return;
    }

    var metaobjectDate = (timerElement.getAttribute('data-metaobject-date') || '').trim();
    var metaobjectStartDate = (timerElement.getAttribute('data-metaobject-start-date') || '').trim();

    var endTime;

    function parseDateToTimestamp(dateString) {
      if (!dateString) return null;
      var trimmed = dateString.trim();
      if (!trimmed) return null;

      var numeric = parseInt(trimmed, 10);
      if (!isNaN(numeric) && numeric > 0) {
        return numeric < 10000000000 ? numeric * 1000 : numeric;
      }

      var parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) return parsed.getTime();

      return null;
    }

    if (metaobjectDate) {
      endTime = parseDateToTimestamp(metaobjectDate);
      if (endTime == null) {
        console.warn('Failed to parse metaobject date:', metaobjectDate);
        return;
      }
    } else {
      return;
    }

    function updateTimer() {
      var now = Date.now();
      var totalRemaining = Math.max(0, Math.floor((endTime - now) / 1000));

      var rem = totalRemaining;
      var days = Math.floor(rem / 86400);
      rem = rem % 86400;
      var hours = Math.floor(rem / 3600);
      rem = rem % 3600;
      var mins = Math.floor(rem / 60);
      var secs = rem % 60;

      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = mins;
      secondsEl.textContent = secs;

      if (progressBarFill) {
        if (metaobjectStartDate) {
          var parsedStartDate = parseDateToTimestamp(metaobjectStartDate);
          if (parsedStartDate !== null && endTime) {
            var calculatedStartTime = parsedStartDate;
            var totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);

            if (totalDurationSeconds > 0) {
              var elapsedSeconds = Math.max(0, Math.floor((now - calculatedStartTime) / 1000));
              var remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
              var progress = 0;

              if (elapsedSeconds <= totalDurationSeconds) {
                progress = (remainingSeconds / totalDurationSeconds) * 100;
              } else {
                progress = 0;
              }

              progressBarFill.style.width = Math.min(100, Math.max(0, progress)) + '%';
            }
          }
        }
      }

      if (totalRemaining <= 0) {
        var intervalId = timerElement.dataset.intervalId;
        if (intervalId) {
          clearInterval(parseInt(intervalId, 10));
          delete timerElement.dataset.intervalId;
        }
        var hideTarget = timerElement.closest('.product-info__block-item') || timerElement.closest('.bk-media-timer-wrapper');
        if (hideTarget) {
          hideTarget.hidden = true;
        }
      }
    }

    updateTimer();
    var stillRemaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    if (stillRemaining > 0) {
      var interval = setInterval(updateTimer, 1000);
      timerElement.dataset.intervalId = String(interval);
    }
  }

  function initTimerBlocks() {
    document.querySelectorAll('.bk-media-timer-block__timer').forEach(function(timer) {
      var existingIntervalId = timer.dataset.intervalId;
      if (existingIntervalId) {
        clearInterval(parseInt(existingIntervalId));
        delete timer.dataset.intervalId;
      }

      timer.dataset.initialized = 'true';
      try {
        initTimerBlock(timer);
      } catch (error) {
        console.error('Error initializing timer block:', error, timer);
        timer.dataset.initialized = 'false';
      }
    });
  }

  function copyTimerDiscountCode(code, copyTrigger) {
    var textEl = copyTrigger.querySelector('.bk-media-timer-block__code-text');
    var originalText = textEl ? textEl.textContent.trim() : '';

    function showFeedback() {
      copyTrigger.classList.add('is-copied');

      if (textEl) {
        textEl.textContent = 'Kopiert!';
        setTimeout(function() {
          textEl.textContent = originalText;
          copyTrigger.classList.remove('is-copied');
        }, 2000);
      } else {
        setTimeout(function() {
          copyTrigger.classList.remove('is-copied');
        }, 2000);
      }
    }

    function fallbackCopy() {
      var textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.top = '-9999px';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        if (document.execCommand('copy')) {
          showFeedback();
        }
      } catch (err) {
        console.error('Failed to copy code:', err);
      } finally {
        document.body.removeChild(textArea);
      }
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(showFeedback).catch(function(err) {
        console.error('Failed to copy code:', err);
        fallbackCopy();
      });
      return;
    }

    fallbackCopy();
  }

  function initTimerCopyButtons() {
    if (document.documentElement.dataset.bkMediaTimerCopyInit === 'true') return;
    document.documentElement.dataset.bkMediaTimerCopyInit = 'true';

    document.addEventListener('click', function(event) {
      var copyTrigger = event.target.closest('.bk-media-timer-block__code-copy');
      if (!copyTrigger) return;

      event.preventDefault();

      var code = copyTrigger.getAttribute('data-code');
      if (!code) return;

      copyTimerDiscountCode(code, copyTrigger);
    });
  }

  function setupTimerRerenderListener() {
    document.querySelectorAll('form[is="product-form"], form[id^="product-form"]').forEach(function(form) {
      if (form.dataset.bkMediaTimerRerenderListener === 'true') return;
      form.dataset.bkMediaTimerRerenderListener = 'true';

      form.addEventListener('product:rerender', function() {
        setTimeout(initTimerBlocks, 100);
      });
    });
  }

  function initializeTimerBlocks() {
    initTimerBlocks();
    initTimerCopyButtons();
    setupTimerRerenderListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeTimerBlocks();
    });
  } else {
    setTimeout(initializeTimerBlocks, 100);
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initializeTimerBlocks, 100);
  });

  function initNaehrwerteAccordions(root) {
    var scope = root && root.querySelector ? root : document;

    scope.querySelectorAll('[data-bk-naehrwerte-accordion]').forEach(function(accordionBlock) {
      if (accordionBlock.dataset.bkNaehrwerteInit === 'true') return;
      accordionBlock.dataset.bkNaehrwerteInit = 'true';

      var tabs = accordionBlock.querySelectorAll('.naehrwerte-tab');
      var contentPanels = accordionBlock.querySelectorAll('.naehrwerte-content-panel');

      function switchToTab(index) {
        if (index < 0 || index >= tabs.length) return;

        tabs.forEach(function(tab) { tab.classList.remove('active'); });
        contentPanels.forEach(function(panel) { panel.classList.remove('active'); });

        if (tabs[index]) tabs[index].classList.add('active');
        if (contentPanels[index]) contentPanels[index].classList.add('active');
      }

      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
          switchToTab(index);
        });
      });

      if (tabs.length) switchToTab(0);
    });
  }

  function initializeNaehrwerteAccordions() {
    initNaehrwerteAccordions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNaehrwerteAccordions);
  } else {
    initializeNaehrwerteAccordions();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initializeNaehrwerteAccordions, 100);
  });

  document.addEventListener('product:rerender', function() {
    setTimeout(initializeNaehrwerteAccordions, 100);
  });
})();

/* bk-media-sparset-builder start */

function initBkMediaSparsetBuilder(root) {
  if (!root || root._bkMediaSparsetInitialized) return;

  const configScript = root.querySelector('[data-sparset-config]');
  if (!configScript) return;

  let config = {};
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Failed to parse sparset config:', error);
    return;
  }

  const productsById = {};
  (config.products || []).forEach((product) => {
    productsById[String(product.id)] = {
      ...product,
      quantityStep: Math.max(1, parseInt(product.quantityStep, 10) || 1),
      pfandVariantId: product.pfandVariantId ? parseInt(product.pfandVariantId, 10) : null
    };
  });

  function getQuantityStep(productOrVariantId) {
    if (productOrVariantId && typeof productOrVariantId === 'object') {
      return Math.max(1, parseInt(productOrVariantId.quantityStep, 10) || 1);
    }

    const product = Object.values(productsById).find((item) => String(item.variantId) === String(productOrVariantId));
    return Math.max(1, parseInt(product?.quantityStep, 10) || 1);
  }

  function getProductByVariantId(variantId) {
    return Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
  }

  function resolvePfandVariantId(product) {
    if (!product) return null;
    if (product.pfandVariantId) return parseInt(product.pfandVariantId, 10);

    const productId = String(product.id);
    for (const rule of config.pfandRules || []) {
      const ids = (rule.productIds || []).map(String);
      if (ids.includes(productId) && rule.variantId) {
        return parseInt(rule.variantId, 10);
      }
    }
    return null;
  }

  function buildPfandCartItems(bundleId, itemQuantities) {
    const pfandByVariant = {};

    Object.keys(itemQuantities).forEach((variantId) => {
      const product = getProductByVariantId(variantId);
      const pfandVariantId = resolvePfandVariantId(product);
      if (!pfandVariantId) return;

      const qty = parseInt(itemQuantities[variantId], 10) || 0;
      if (qty <= 0) return;

      pfandByVariant[pfandVariantId] = (pfandByVariant[pfandVariantId] || 0) + qty;
    });

    return Object.keys(pfandByVariant).map((id) => ({
      id: parseInt(id, 10),
      quantity: pfandByVariant[id],
      properties: {
        // Do NOT set _BundleId — that makes the cart treat Pfand as the Sparset parent
        // (shared bundle_components_* cart attribute + bundle pricing).
        _PfandLocked: 'true',
        _SparsetPfandBundleId: bundleId,
        _DiscountExempt: 'true'
      }
    }));
  }

  async function fetchCartJson() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }
    return response.json();
  }

  function cartItemHasPfandBundleId(item, bundleId) {
    const props = item?.properties || {};
    return String(props._SparsetPfandBundleId || '') === String(bundleId);
  }

  function sparsetPfandQuantityInCart(cart, pfandVariantId, bundleId) {
    return (cart?.items || []).reduce((sum, item) => {
      if (!cartItemHasPfandBundleId(item, bundleId)) return sum;
      if (Number(item.variant_id) !== Number(pfandVariantId)) return sum;
      return sum + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  async function ensureSparsetPfandInCart(bundleId, pfandItems, sections) {
    if (!pfandItems.length) return null;

    let cart = await fetchCartJson();
    const missing = pfandItems.reduce((list, pfandItem) => {
      const already = sparsetPfandQuantityInCart(cart, pfandItem.id, bundleId);
      const needed = parseInt(pfandItem.quantity, 10) || 0;
      if (needed > already) {
        list.push({ ...pfandItem, quantity: needed - already });
      }
      return list;
    }, []);

    if (!missing.length) return cart;

    const addBody = { items: missing };
    if (sections) {
      addBody.sections = sections;
    }

    const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(addBody)
    });

    if (!addResponse.ok) {
      const errorData = await addResponse.json().catch(() => ({}));
      console.error('Failed to add Sparset Pfand lines:', errorData);
      return cart;
    }

    const addJson = await addResponse.json();
    cart = await fetchCartJson();
    if (addJson.sections) {
      cart.sections = Object.assign({}, cart.sections || {}, addJson.sections);
    }
    return cart;
  }

  const goals = (config.goals || []).slice().sort((a, b) => {
    const aThreshold = parseInt(a.threshold != null ? a.threshold : a.quantity, 10) || 0;
    const bThreshold = parseInt(b.threshold != null ? b.threshold : b.quantity, 10) || 0;
    return aThreshold - bThreshold;
  }).map((goal) => ({
    threshold: parseInt(goal.threshold != null ? goal.threshold : goal.quantity, 10) || 0,
    discount: parseInt(goal.discount, 10) || 0,
    subtitle: goal.subtitle || ''
  }));
  const selectedVariantIds = [];
  const referralInput = root.querySelector('[data-sparset-referral-input]');
  let referralCodeValue = '';
  let resolvedPreviewDiscount = {
    type: null,
    value: 0,
    code: null,
    loaded: false
  };
  let previewDiscountRetried = false;
  const panel = root.querySelector('.bk-media-sparset-builder__panel');
  const countEls = root.querySelectorAll('[data-sparset-count]');
  const goalsFill = root.querySelector('[data-goals-fill]');
  const goalNodes = root.querySelectorAll('.bk-media-sparset-builder__goal-node');
  const slots = root.querySelectorAll('.bk-media-sparset-builder__slot');
  const atcButton = root.querySelector('[data-action="add-to-cart"]');
  const atcSpinner = root.querySelector('[data-sparset-atc-spinner]');
  const feedbackOverlay = root.querySelector('[data-sparset-feedback]');
  const feedbackLoading = root.querySelector('[data-sparset-feedback-loading]');
  const feedbackSuccess = root.querySelector('[data-sparset-feedback-success]');
  const savingsRow = root.querySelector('[data-sparset-savings]');
  const savingsAmountEl = root.querySelector('[data-sparset-savings-amount]');
  const totalRow = root.querySelector('[data-sparset-total]');
  const totalPriceEl = root.querySelector('[data-sparset-total-price]');
  const totalCompareEl = root.querySelector('[data-sparset-total-compare]');
  const discountAppliedRow = root.querySelector('[data-sparset-discount-applied]');
  const discountLabelEl = root.querySelector('[data-sparset-discount-label]');
  const discountAmountEl = root.querySelector('[data-sparset-discount-amount]');
  const searchInput = root.querySelector('[data-sparset-search]');
  const searchWrap = root.querySelector('[data-sparset-search-wrap]');
  const searchToggle = root.querySelector('[data-sparset-search-toggle]');
  const searchEmptyEl = root.querySelector('[data-sparset-search-empty]');
  const filterButtons = root.querySelectorAll('[data-sparset-filter]');
  const minProducts = parseInt(root.getAttribute('data-min-products') || config.minProducts || 2, 10);
  const maxProducts = parseInt(root.getAttribute('data-max-products') || config.maxProducts || 12, 10);
  const placeholderSlots = parseInt(root.getAttribute('data-placeholder-slots') || '5', 10);
  const showReferralCode = Boolean(config.showReferralCode);

  function hasFreeProductSlot() {
    return Boolean(config.freeProduct?.title);
  }

  function getSelectableMaxProducts() {
    return hasFreeProductSlot() ? Math.max(0, maxProducts - 1) : maxProducts;
  }

  function getSelectedIndexForSlot(slotIndex) {
    return hasFreeProductSlot() ? slotIndex - 1 : slotIndex;
  }

  function renderFreeProductSlot(slot) {
    const freeProduct = config.freeProduct;
    const titleEl = slot.querySelector('[data-slot-title]');
    const subtitleEl = slot.querySelector('[data-slot-subtitle]');
    const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
    const removeBtn = slot.querySelector('[data-action="remove-slot"]');
    const badgeText = freeProduct.badge || 'GRATIS';

    slot.classList.add('is-filled', 'is-free-product');
    if (titleEl) titleEl.textContent = freeProduct.title;
    if (subtitleEl) {
      subtitleEl.innerHTML = `<span class="badge bk-media-sparset-builder__slot-gratis-badge">${badgeText}</span>`;
    }
    if (iconEl) {
      iconEl.innerHTML = freeProduct.image
        ? `<img src="${freeProduct.image}" alt="${freeProduct.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
        : '';
    }
    if (removeBtn) removeBtn.hidden = true;
  }

  function formatSparsetMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }

    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `€${amount}`;
  }

  function getSelectionSubtotal() {
    let subtotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      if (!product) return;
      subtotal += parseInt(product.price, 10) || 0;
    });

    return subtotal;
  }

  function getCurrentDiscount(amountCents) {
    let current = null;
    goals.forEach((goal) => {
      if (amountCents >= goal.threshold) {
        current = goal;
      }
    });
    return current;
  }

  function getDiscountPercent(amountCents) {
    const currentDiscount = getCurrentDiscount(amountCents);
    return currentDiscount ? currentDiscount.discount : 0;
  }

  function getPreviewDiscountFallbackPercent() {
    return parseInt(config.previewDiscountPercent, 10) || 0;
  }

  function getPreviewDiscountPercent() {
    if (!resolvedPreviewDiscount.loaded) {
      return getPreviewDiscountFallbackPercent();
    }

    if (resolvedPreviewDiscount.type === 'percentage') {
      return resolvedPreviewDiscount.value || 0;
    }

    return getPreviewDiscountFallbackPercent();
  }

  function getPreviewDiscountBadgeText() {
    const previewPercent = getPreviewDiscountPercent();

    if (resolvedPreviewDiscount.code && resolvedPreviewDiscount.type === 'fixed') {
      return `-${formatSparsetMoney(Math.round(resolvedPreviewDiscount.value * 100))}`;
    }

    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function combineDiscountPercents(goalPercent, previewPercent) {
    const goal = parseFloat(goalPercent) || 0;
    const preview = parseFloat(previewPercent) || 0;

    if (goal <= 0 && preview <= 0) return 0;
    if (goal <= 0) return Math.round(preview);
    if (preview <= 0) return Math.round(goal);

    return Math.round(100 - ((100 - goal) * (100 - preview) / 100));
  }

  function getCombinedDiscountPercent(goalPercent) {
    return combineDiscountPercents(goalPercent, getPreviewDiscountPercent());
  }

  function getDisplayDiscountPercent(amountCents) {
    return getCombinedDiscountPercent(getDiscountPercent(amountCents));
  }

  function getTierPercentForAmount(amountCents) {
    return getDiscountPercent(amountCents);
  }

  function getReferenceUnitPrice(basePriceCents, compareAtCents) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;

    if (config.showVariantCompareAt && compareAt > basePrice) {
      return compareAt;
    }

    return basePrice;
  }

  function applyUnitDiscountTruncated(basePriceCents, discountPercent) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const discount = parseFloat(discountPercent) || 0;

    if (!discount || discount <= 0 || basePrice <= 0) {
      return basePrice;
    }

    const discountAmount = Math.round(basePrice * discount / 100);
    return basePrice - discountAmount;
  }

  function getDiscountedUnitPriceStacked(basePriceCents, goalPercent, previewPercent) {
    const afterGoal = applyUnitDiscountTruncated(basePriceCents, goalPercent);
    return applyUnitDiscountTruncated(afterGoal, previewPercent);
  }

  function getProductBadgePercent(basePriceCents, compareAtCents, tierGoalPercent) {
    const tierGoal = parseFloat(tierGoalPercent) || 0;
    const previewPercent = getPreviewDiscountPercent();

    if (tierGoal <= 0 && previewPercent <= 0) {
      return 0;
    }

    const referencePrice = getReferenceUnitPrice(basePriceCents, compareAtCents);
    const salePrice = getDiscountedUnitPriceStacked(basePriceCents, tierGoal, previewPercent);

    if (referencePrice <= 0 || salePrice >= referencePrice) {
      return getCombinedDiscountPercent(tierGoal);
    }

    return Math.round((referencePrice - salePrice) / referencePrice * 100);
  }

  async function resolvePreviewDiscountCode() {
    const code = (config.previewDiscountCode || '').trim();
    const fallbackPercent = getPreviewDiscountFallbackPercent();

    if (!code) {
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
      return;
    }

    try {
      const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
      const existingApps = cartBefore.cart_level_discount_applications || [];
      const existingCode = existingApps[0]?.title || '';
      const hadDiscount = existingApps.length > 0;
      const alreadyApplied = hadDiscount && existingCode.toLowerCase() === code.toLowerCase();

      if (alreadyApplied) {
        const app = existingApps[0];
        if (app.value_type === 'percentage') {
          resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
        } else if (app.value_type === 'fixed_amount') {
          resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
        } else {
          resolvedPreviewDiscount = { type: fallbackPercent > 0 ? 'percentage' : null, value: fallbackPercent, code: null, loaded: true };
        }
        return;
      }

      const cartAfter = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then((response) => response.json());

      const codeEntry = (cartAfter.discount_codes || []).find((entry) =>
        String(entry.code || '').toLowerCase() === code.toLowerCase()
      );

      const needsRestore = !hadDiscount || existingCode.toLowerCase() !== code.toLowerCase();

      if (!codeEntry?.applicable) {
        if (needsRestore) {
          await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
          });
        }

        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
        return;
      }

      const app = (cartAfter.cart_level_discount_applications || []).find((entry) =>
        String(entry.title || '').toLowerCase() === code.toLowerCase()
      ) || cartAfter.cart_level_discount_applications?.[0];

      if (app?.value_type === 'percentage') {
        resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
      } else if (app?.value_type === 'fixed_amount') {
        resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
      } else {
        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
      }

      if (needsRestore) {
        const restoredCart = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
        }).then((response) => response.json());

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'sparset:discount-preview',
            cart: restoredCart
          }
        }));
      }
    } catch (error) {
      console.error('Failed to resolve preview discount code:', error);
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
    }
  }

  function maybeRetryPreviewDiscount(count) {
    const code = (config.previewDiscountCode || '').trim();
    if (!code || previewDiscountRetried || count < minProducts) return;
    if (resolvedPreviewDiscount.code) return;

    previewDiscountRetried = true;
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  function getPreviewDiscountSavings(amountCents) {
    if (!amountCents || selectedVariantIds.length === 0) return 0;

    const goalPercent = getDiscountPercent(amountCents);
    let afterGoalTotal = 0;
    let afterPreviewTotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      if (!product) return;

      const afterGoal = getDiscountedUnitPriceStacked(product.price, goalPercent, 0);
      const afterPreview = getDiscountedUnitPriceStacked(product.price, goalPercent, getPreviewDiscountPercent());
      afterGoalTotal += afterGoal;
      afterPreviewTotal += afterPreview;
    });

    if (!afterGoalTotal) return 0;

    if (resolvedPreviewDiscount.type === 'fixed' && resolvedPreviewDiscount.value > 0) {
      return Math.min(afterGoalTotal, Math.round(resolvedPreviewDiscount.value * 100));
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return afterGoalTotal - afterPreviewTotal;
    }

    return 0;
  }

  function getPreviewDiscountLabel() {
    if (resolvedPreviewDiscount.code) {
      return resolvedPreviewDiscount.code;
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function hasActivePreviewDiscount() {
    if (!resolvedPreviewDiscount.loaded) return false;
    if (resolvedPreviewDiscount.code) return true;
    return getPreviewDiscountPercent() > 0;
  }

  function updatePreviewDiscountRow(count, totals) {
    if (!discountAppliedRow || !discountLabelEl || !discountAmountEl) return;

    if (!hasActivePreviewDiscount()) {
      discountAppliedRow.hidden = true;
      return;
    }

    const label = getPreviewDiscountLabel();
    if (!label) {
      discountAppliedRow.hidden = true;
      return;
    }

    discountAppliedRow.hidden = false;
    discountLabelEl.textContent = label;

    if (count > 0 && totals.originalTotal > 0) {
      const savings = getPreviewDiscountSavings(totals.priceSubtotal);
      if (savings > 0) {
        discountAmountEl.textContent = `-${formatSparsetMoney(savings)}`;
        discountAmountEl.hidden = false;
        return;
      }
    }

    discountAmountEl.textContent = '';
    discountAmountEl.hidden = true;
  }

  function renderPriceMarkup(basePriceCents, goalPercent, compareAtCents, includePreview) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;
    const showCompareAt = config.showVariantCompareAt && compareAt > basePrice;
    const previewPercent = includePreview === false ? 0 : getPreviewDiscountPercent();
    const salePrice = getDiscountedUnitPriceStacked(basePrice, goalPercent, previewPercent);
    const referencePrice = getReferenceUnitPrice(basePrice, compareAt);

    if (showCompareAt) {
      if (salePrice >= referencePrice) {
        return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
      }

      return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(referencePrice)}</compare-at-price>`;
    }

    if ((!goalPercent && !previewPercent) || salePrice >= basePrice) {
      return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
    }

    return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(basePrice)}</compare-at-price>`;
  }

  function getSelectionTotals() {
    let priceSubtotal = 0;
    let compareSubtotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      if (!product) return;

      priceSubtotal += product.price;
      compareSubtotal += getReferenceUnitPrice(product.price, product.compareAtPrice);
    });

    const goalPercent = getDiscountPercent(priceSubtotal);
    const discountAmount = goalPercent > 0 ? Math.round(priceSubtotal * goalPercent / 100) : 0;
    const discountedTotal = priceSubtotal - discountAmount;
    const originalTotal = priceSubtotal;
    const savings = (config.showVariantCompareAt && compareSubtotal > priceSubtotal)
      ? compareSubtotal - discountedTotal
      : priceSubtotal - discountedTotal;

    return {
      priceSubtotal,
      compareSubtotal,
      originalTotal,
      discountedTotal,
      savings,
      goalPercent
    };
  }

  function getGoalSubtitleForSlot(slotIndex) {
    const goalIndex = hasFreeProductSlot() ? Math.max(0, slotIndex - 1) : slotIndex;
    if (goalIndex < goals.length) {
      return goals[goalIndex].subtitle || '';
    }
    return '';
  }

  function getProductCount(productId) {
    return selectedVariantIds.filter((variantId) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(variantId));
      return product && String(product.id) === String(productId);
    }).length;
  }

  function setProductQuantity(variantId, productId, quantity) {
    const remaining = selectedVariantIds.filter((id) => {
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(id));
      return !product || String(product.id) !== String(productId);
    });

    const maxQty = getSelectableMaxProducts() - remaining.length;
    const clampedQty = Math.max(0, Math.min(quantity, maxQty));

    selectedVariantIds.length = 0;
    selectedVariantIds.push(...remaining);

    for (let i = 0; i < clampedQty; i += 1) {
      selectedVariantIds.push(String(variantId));
    }

    updateUI();
  }

  function bindQuantitySelector(card) {
    const selector = card.querySelector('quantity-selector');
    if (!selector || selector.dataset.sparsetBound === 'true') return;

    const productId = String(card.getAttribute('data-product-id'));
    const variantId = card.getAttribute('data-variant-id');
    const input = card.querySelector('[data-sparset-quantity-input]');
    const minusBtn = selector.querySelector('button:first-of-type');
    const plusBtn = selector.querySelector('button:last-of-type');

    const applyQuantity = (quantity) => {
      setProductQuantity(variantId, productId, quantity);
    };

    const onMinus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) - 1);
    };

    const onPlus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) + 1);
    };

    const onInputChange = () => {
      applyQuantity(parseInt(input.value, 10) || 0);
    };

    minusBtn?.addEventListener('click', onMinus, true);
    plusBtn?.addEventListener('click', onPlus, true);
    input?.addEventListener('change', onInputChange);

    selector.dataset.sparsetBound = 'true';
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function getActiveFilterButton() {
    return root.querySelector('[data-sparset-filter][aria-pressed="true"]');
  }

  function cardMatchesFilter(card, filterButton) {
    if (!filterButton || filterButton.getAttribute('data-filter-all') === 'true') return true;

    const filterId = String(filterButton.getAttribute('data-filter-id') || '');
    const filterKeys = String(filterButton.getAttribute('data-filter-keys') || '')
      .split(/\s+/)
      .filter(Boolean);
    const cardIds = String(card.getAttribute('data-filter-ids') || '').split(/\s+/);
    const cardKeys = String(card.getAttribute('data-filter-keys') || '').split(/\s+/);

    if (filterId && cardIds.includes(filterId)) return true;
    return filterKeys.some((key) => cardKeys.includes(key));
  }

  function setActiveFilter(button) {
    filterButtons.forEach((filterButton) => {
      filterButton.setAttribute('aria-pressed', filterButton === button ? 'true' : 'false');
    });
    filterProductCards();
  }

  function setSearchOpen(open) {
    if (!searchWrap || !searchToggle) return;
    searchWrap.classList.toggle('is-open', open);
    searchToggle.setAttribute('aria-expanded', String(open));
    const searchIcon = searchToggle.querySelector('[data-search-icon]');
    const closeIcon = searchToggle.querySelector('[data-close-icon]');
    if (searchIcon) searchIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
    if (searchInput) {
      searchInput.setAttribute('tabindex', open ? '0' : '-1');
      if (open) searchInput.focus();
    }
  }

  function updateSearchToggleState() {
    if (!searchToggle || !searchInput) return;
    searchToggle.classList.toggle('has-query', Boolean(searchInput.value.trim()));
  }

  function filterProductCards() {
    const query = searchInput ? normalizeSearchValue(searchInput.value) : '';
    const activeFilter = getActiveFilterButton();
    const hasActiveFilter = Boolean(activeFilter && activeFilter.getAttribute('data-filter-all') !== 'true');
    let visibleCount = 0;

    root.querySelectorAll('.bk-media-sparset-builder__card').forEach((card) => {
      const title = normalizeSearchValue(
        card.getAttribute('data-search-title') || card.querySelector('.bk-media-sparset-builder__card-title')?.textContent || ''
      );
      const matchesSearch = !query || title.includes(query);
      const matchesFilter = cardMatchesFilter(card, activeFilter);
      const matches = matchesSearch && matchesFilter;
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (searchEmptyEl) {
      searchEmptyEl.hidden = visibleCount > 0 || (!query && !hasActiveFilter);
    }

    updateSearchToggleState();
  }

  function updateProductCards() {
    const count = selectedVariantIds.length;
    const atMax = count >= getSelectableMaxProducts();
    const currentSubtotal = getSelectionSubtotal();

    root.querySelectorAll('.bk-media-sparset-builder__card').forEach((card) => {
      const productId = String(card.getAttribute('data-product-id'));
      const addButton = card.querySelector('[data-action="add-product"]');
      const quantityWrap = card.querySelector('[data-sparset-quantity-wrap]');
      const quantityInput = card.querySelector('[data-sparset-quantity-input]');
      const priceEl = card.querySelector('[data-card-price]');
      const discountBadgeWrap = card.querySelector('[data-card-discount-badge-wrap]');
      const discountBadge = card.querySelector('[data-card-discount-badge]');
      const productCount = getProductCount(productId);
      const basePrice = parseInt(card.getAttribute('data-base-price') || priceEl?.getAttribute('data-base-price') || '0', 10);
      const compareAtPrice = parseInt(card.getAttribute('data-compare-at-price') || '0', 10);
      const previewSubtotal = productCount > 0 ? currentSubtotal : currentSubtotal + basePrice;
      const cardTierPercent = getTierPercentForAmount(previewSubtotal);
      const badgePercent = getProductBadgePercent(basePrice, compareAtPrice, cardTierPercent);

      card.classList.toggle('is-selected', productCount > 0);
      card.classList.toggle('is-addable', card.getAttribute('data-available') === 'true' && !atMax);

      if (priceEl && basePrice > 0) {
        priceEl.innerHTML = renderPriceMarkup(basePrice, cardTierPercent, compareAtPrice);
      }

      if (discountBadgeWrap && discountBadge) {
        if (badgePercent > 0) {
          discountBadge.textContent = `-${badgePercent}%`;
          discountBadgeWrap.hidden = false;
        } else {
          discountBadge.textContent = '';
          discountBadgeWrap.hidden = true;
        }
      }

      if (productCount > 0) {
        if (addButton) addButton.hidden = true;
        if (quantityWrap) quantityWrap.hidden = false;
        if (quantityInput) {
          quantityInput.value = String(productCount);
          quantityInput.size = Math.max(String(productCount).length + 1, 2);
        }
        bindQuantitySelector(card);
      } else {
        if (addButton) {
          addButton.hidden = false;
          addButton.disabled = atMax || card.getAttribute('data-available') !== 'true';
        }
        if (quantityWrap) quantityWrap.hidden = true;
      }
    });

    filterProductCards();
  }

  function adjustGoalNodePositions() {
    const track = root.querySelector('.bk-media-sparset-builder__goals-track');
    if (!track || !goalNodes.length) return;

    const inset = 8;
    const minBound = inset;
    const maxBound = 100 - inset;
    const trackWidth = track.offsetWidth || 1;

    const items = Array.from(goalNodes).map((node) => ({
      node,
      ideal: parseFloat(node.getAttribute('data-goal-ideal-position') || node.getAttribute('data-goal-position') || '0'),
      threshold: parseInt(node.getAttribute('data-goal-threshold'), 10) || 0
    })).sort((a, b) => a.ideal - b.ideal);

    const count = items.length;
    if (!count) return;

    let maxNodeWidth = 44;
    items.forEach((item) => {
      maxNodeWidth = Math.max(maxNodeWidth, item.node.offsetWidth || 0);
    });

    const minGapPercent = Math.min(16, Math.max(7, (maxNodeWidth / trackWidth) * 100 * 0.95));
    let positions = [];

    if (count === 1) {
      positions = [Math.max(minBound, Math.min(maxBound, items[0].ideal))];
    } else {
      const ideals = items.map((item) => item.ideal);
      const available = maxBound - minBound;
      const required = (count - 1) * minGapPercent;
      const extra = available - required;

      if (extra <= 0) {
        for (let i = 0; i < count; i += 1) {
          positions[i] = minBound + (i / (count - 1)) * available;
        }
      } else {
        const idealGaps = [];
        let totalIdealGap = 0;

        for (let i = 0; i < count - 1; i += 1) {
          const gap = Math.max(0, ideals[i + 1] - ideals[i]);
          idealGaps.push(gap);
          totalIdealGap += gap;
        }

        positions[0] = minBound;
        for (let i = 0; i < count - 1; i += 1) {
          const extraGap = totalIdealGap > 0 ? (idealGaps[i] / totalIdealGap) * extra : extra / (count - 1);
          positions[i + 1] = positions[i] + minGapPercent + extraGap;
        }
      }
    }

    items.forEach((item, index) => {
      const position = Math.round(positions[index] * 10) / 10;
      item.node.style.setProperty('--goal-position', `${position}%`);
      item.node.setAttribute('data-goal-position', String(position));
    });
  }

  function getGoalNodesData() {
    return Array.from(goalNodes).map((node) => ({
      threshold: parseInt(node.getAttribute('data-goal-threshold'), 10) || 0,
      position: parseFloat(node.getAttribute('data-goal-position') || node.style.getPropertyValue('--goal-position') || '0')
    })).sort((a, b) => a.threshold - b.threshold);
  }

  function getProgressPercent(amountCents) {
    const nodes = getGoalNodesData();

    if (!nodes.length) {
      return amountCents > 0 ? 100 : 0;
    }

    if (amountCents <= 0) return 0;

    const lastNode = nodes[nodes.length - 1];
    if (amountCents >= lastNode.threshold) {
      return lastNode.position;
    }

    let prev = { threshold: 0, position: 0 };

    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];

      if (amountCents === node.threshold) {
        return node.position;
      }

      if (amountCents < node.threshold) {
        const range = node.threshold - prev.threshold;
        const ratio = range > 0 ? (amountCents - prev.threshold) / range : 0;
        return prev.position + ratio * (node.position - prev.position);
      }

      prev = node;
    }

    return lastNode.position;
  }

  function updateUI() {
    const count = selectedVariantIds.length;
    const totals = getSelectionTotals();
    const amountCents = totals.priceSubtotal;
    const progress = getProgressPercent(amountCents);
    const goalPercent = totals.goalPercent;

    countEls.forEach((el) => {
      el.textContent = `${count} / ${maxProducts}`;
    });

    if (goalsFill) {
      goalsFill.style.width = `${progress}%`;
    }

    goalNodes.forEach((node) => {
      const threshold = parseInt(node.getAttribute('data-goal-threshold'), 10) || 0;
      const goalDiscount = parseInt(node.getAttribute('data-goal-discount'), 10);
      const discountEl = node.querySelector('.bk-media-sparset-builder__goal-discount');

      node.classList.toggle('is-reached', amountCents >= threshold);

      if (discountEl && !Number.isNaN(goalDiscount)) {
        discountEl.textContent = `${getCombinedDiscountPercent(goalDiscount)}%`;
      }
    });

    let emptyPlaceholderCount = 0;

    slots.forEach((slot, index) => {
      if (slot.hasAttribute('data-free-product-slot')) {
        renderFreeProductSlot(slot);
        slot.hidden = false;
        return;
      }

      const titleEl = slot.querySelector('[data-slot-title]');
      const subtitleEl = slot.querySelector('[data-slot-subtitle]');
      const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
      const removeBtn = slot.querySelector('[data-action="remove-slot"]');
      const selectedIndex = getSelectedIndexForSlot(index);
      const variantId = selectedIndex >= 0 ? selectedVariantIds[selectedIndex] : null;
      const product = variantId ? Object.values(productsById).find((item) => String(item.variantId) === String(variantId)) : null;

      slot.classList.remove('is-free-product');

      if (product) {
        slot.hidden = false;
        slot.classList.add('is-filled');
        if (titleEl) titleEl.textContent = product.title;
        if (subtitleEl) {
          subtitleEl.innerHTML = renderPriceMarkup(product.price, goalPercent, product.compareAtPrice, false);
        }
        if (iconEl) {
          iconEl.innerHTML = product.image
            ? `<img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
            : '';
        }
        if (removeBtn) removeBtn.hidden = false;
      } else {
        emptyPlaceholderCount += 1;
        slot.hidden = emptyPlaceholderCount > placeholderSlots;
        slot.classList.remove('is-filled');
        if (titleEl) titleEl.textContent = config.emptySlotText || 'Wähle ein Produkt';
        if (subtitleEl) {
          const subtitle = getGoalSubtitleForSlot(index);
          subtitleEl.textContent = subtitle;
        }
        if (iconEl) {
          iconEl.innerHTML = '<svg role="presentation" focusable="false" width="14" height="14" viewBox="0 0 10 10"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        }
        if (removeBtn) removeBtn.hidden = true;
      }
    });

    if (savingsRow && savingsAmountEl) {
      const showSavings = count > 0 && totals.savings > 0;
      savingsRow.hidden = !showSavings;
      if (showSavings) {
        savingsAmountEl.textContent = `-${formatSparsetMoney(totals.savings)}`;
      }
    }

    updatePreviewDiscountRow(count, totals);

    if (totalRow && totalPriceEl) {
      const showTotal = count > 0;
      totalRow.hidden = !showTotal;

      if (showTotal) {
        totalPriceEl.textContent = formatSparsetMoney(totals.discountedTotal);

        if (totalCompareEl) {
          if (goalPercent > 0 && totals.discountedTotal < totals.originalTotal) {
            totalCompareEl.textContent = formatSparsetMoney(totals.originalTotal);
            totalCompareEl.hidden = false;
          } else {
            totalCompareEl.textContent = '';
            totalCompareEl.hidden = true;
          }
        }
      }
    }

    if (atcButton) {
      atcButton.disabled = count < minProducts;
    }

    updateProductCards();
    maybeRetryPreviewDiscount(count);
  }

  function addProduct(variantId) {
    if (selectedVariantIds.length >= getSelectableMaxProducts()) return false;
    selectedVariantIds.push(String(variantId));
    updateUI();
    return true;
  }

  function removeProductAt(index) {
    if (index < 0 || index >= selectedVariantIds.length) return;
    selectedVariantIds.splice(index, 1);
    updateUI();
  }

  function handleCardAdd(card) {
    if (!card || card.getAttribute('data-available') !== 'true') return;
    if (selectedVariantIds.length >= getSelectableMaxProducts()) return;
    addProduct(card.getAttribute('data-variant-id'));
  }

  if (showReferralCode) {
    referralInput?.addEventListener('input', function () {
      referralCodeValue = referralInput.value.trim();
    });
  }

  root.addEventListener('click', function (event) {
    const addProductBtn = event.target.closest('[data-action="add-product"]');
    if (addProductBtn) {
      const card = addProductBtn.closest('.bk-media-sparset-builder__card');
      if (!card || addProductBtn.disabled) return;
      handleCardAdd(card);
      return;
    }

    const card = event.target.closest('.bk-media-sparset-builder__card');
    if (card && !event.target.closest('quantity-selector')) {
      handleCardAdd(card);
      return;
    }

    const removeSlotBtn = event.target.closest('[data-action="remove-slot"]');
    if (removeSlotBtn) {
      const slot = removeSlotBtn.closest('.bk-media-sparset-builder__slot');
      if (!slot || slot.hasAttribute('data-free-product-slot')) return;
      const slotIndex = parseInt(slot.getAttribute('data-slot-index'), 10);
      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      if (selectedIndex < 0) return;
      removeProductAt(selectedIndex);
      return;
    }

    const toggleBtn = event.target.closest('[data-action="toggle-panel"]');
    if (toggleBtn && panel) {
      const expanded = panel.getAttribute('data-expanded') === 'true';
      panel.setAttribute('data-expanded', expanded ? 'false' : 'true');
      toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      return;
    }

    const atcBtn = event.target.closest('[data-action="add-to-cart"]');
    if (atcBtn) {
      handleAddToCart(atcBtn);
    }
  });

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function spawnSparsetConfetti() {
    const container = root.querySelector('[data-sparset-confetti]');
    if (!container) return;

    container.innerHTML = '';
    const colors = ['#b4d462', '#faca4f', '#353531', '#fbf9f8', '#f5f0e4'];
    const pieceCount = 28;

    for (let i = 0; i < pieceCount; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'bk-media-sparset-builder__confetti-piece';
      const angle = (Math.PI * 2 * i) / pieceCount + (Math.random() * 0.4 - 0.2);
      const distance = 60 + Math.random() * 90;
      piece.style.setProperty('--confetti-x', `${Math.cos(angle) * distance}px`);
      piece.style.setProperty('--confetti-y', `${Math.sin(angle) * distance - 40}px`);
      piece.style.setProperty('--confetti-rotation', `${Math.random() * 540 - 270}deg`);
      piece.style.setProperty('--confetti-delay', `${Math.random() * 0.12}s`);
      piece.style.setProperty('--confetti-color', colors[i % colors.length]);
      piece.style.setProperty('--confetti-duration', `${0.75 + Math.random() * 0.55}s`);
      piece.style.setProperty('--confetti-size', `${5 + Math.random() * 5}px`);
      container.appendChild(piece);
    }
  }

  function setSparsetFeedbackState(state) {
    if (!feedbackOverlay) return;

    if (state === 'loading') {
      feedbackOverlay.hidden = false;
      feedbackOverlay.setAttribute('aria-hidden', 'false');
      if (panel) panel.classList.add('is-processing');
      if (feedbackLoading) feedbackLoading.hidden = false;
      if (feedbackSuccess) feedbackSuccess.hidden = true;
      if (atcSpinner) atcSpinner.hidden = false;
      return;
    }

    if (state === 'success') {
      feedbackOverlay.hidden = false;
      feedbackOverlay.setAttribute('aria-hidden', 'false');
      if (panel) {
        panel.classList.add('is-processing');
        panel.classList.add('is-success');
      }
      if (feedbackLoading) feedbackLoading.hidden = true;
      if (feedbackSuccess) feedbackSuccess.hidden = false;
      spawnSparsetConfetti();
      return;
    }

    feedbackOverlay.hidden = true;
    feedbackOverlay.setAttribute('aria-hidden', 'true');
    if (feedbackLoading) feedbackLoading.hidden = true;
    if (feedbackSuccess) feedbackSuccess.hidden = true;
    if (atcSpinner) atcSpinner.hidden = true;
    if (panel) {
      panel.classList.remove('is-processing');
      panel.classList.remove('is-success');
    }
  }

  function getReferralCodeFromUrl() {
    const param = (config.referralUrlParam || 'ref').trim();
    if (!param) return '';

    try {
      const value = new URLSearchParams(window.location.search).get(param);
      return value ? value.trim() : '';
    } catch (error) {
      return '';
    }
  }

  function getActiveReferralCode() {
    if (!showReferralCode) return '';

    const fromInput = referralInput?.value?.trim();
    if (fromInput) return fromInput;
    if (referralCodeValue) return referralCodeValue;
    return (config.defaultReferralCode || '').trim();
  }

  function initReferralCode() {
    if (!showReferralCode) return;

    referralCodeValue = getReferralCodeFromUrl() || (config.defaultReferralCode || '').trim();

    if (referralInput && referralCodeValue) {
      referralInput.value = referralCodeValue;
    }
  }

  async function updateCartTrackingAttributes(referralCode, discountPercent, bundleMeta = null) {
    const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    const attributes = {};

    if (cartBefore.attributes) {
      Object.keys(cartBefore.attributes).forEach((key) => {
        const value = cartBefore.attributes[key];
        if (value != null && String(value).trim() !== '') {
          attributes[key] = String(value);
        }
      });
    }

    if (showReferralCode) {
      if (referralCode) {
        attributes.referral_code = referralCode;
      } else {
        delete attributes.referral_code;
      }
    }

    if (discountPercent > 0) {
      attributes.bundle_discount_percent = String(discountPercent);
    } else {
      delete attributes.bundle_discount_percent;
    }

    if (bundleMeta?.bundleId && bundleMeta.bundleComponents) {
      attributes[`bundle_components_${bundleMeta.bundleId}`] = bundleMeta.bundleComponents;
    }

    if (bundleMeta?.bundleId && bundleMeta.totals) {
      attributes[`bundle_compare_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.priceSubtotal || 0);
      attributes[`bundle_sale_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.discountedTotal || 0);
      attributes[`bundle_compare_at_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.compareSubtotal || 0);
      attributes[`bundle_discount_percent_${bundleMeta.bundleId}`] = String(bundleMeta.discountPercent || 0);
      attributes[`bundle_show_compare_at_${bundleMeta.bundleId}`] = config.showVariantCompareAt ? 'true' : 'false';
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Failed to update cart tracking attributes');
    }

    return response.json();
  }

  function generateBundleId(group) {
    const bundleGroup = group || 'starter';
    let instanceId;

    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      instanceId = crypto.randomUUID().replace(/-/g, '');
    } else {
      instanceId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    }

    return `${bundleGroup}-${instanceId}`;
  }

  function buildBundleComponentsProperty(itemQuantities) {
    return Object.keys(itemQuantities).map((id) => {
      const qty = itemQuantities[id];
      const product = Object.values(productsById).find((item) => String(item.variantId) === String(id));
      const title = encodeURIComponent(product?.title || '');
      const image = product?.image ? encodeURIComponent(product.image) : '';
      return image ? `${id}::${qty}::${title}::${image}` : `${id}::${qty}::${title}`;
    }).join('||');
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleTotals, bundleComponents, tracking = {}) {
    const props = {
      _BundleId: bundleId,
      _BundleIsParent: 'true',
      _BundleRole: 'parent'
    };

    if (parentVariantId) {
      props._BundleParentVariantId = String(parentVariantId);
    }

    if (config.parentHandle) {
      props._BundleParentHandle = String(config.parentHandle);
    }

    if (config.parentImage) {
      props._BundleParentImage = String(config.parentImage);
    }

    if (bundleTitle) {
      props._BundleTitle = bundleTitle;
    }

    if (bundleTotals?.priceSubtotal > 0) {
      props._BundleCompareTotal = String(bundleTotals.priceSubtotal);
    }

    if (bundleTotals?.compareSubtotal > 0) {
      props._BundleCompareAtTotal = String(bundleTotals.compareSubtotal);
    }

    if (bundleTotals?.discountedTotal > 0) {
      props._BundleDiscountedTotal = String(bundleTotals.discountedTotal);
    }

    props._BundleShowVariantCompareAt = config.showVariantCompareAt ? 'true' : 'false';

    props._BundlePricing = [
      bundleTotals?.priceSubtotal || 0,
      bundleTotals?.discountedTotal || 0,
      tracking.discountPercent || 0,
      bundleTotals?.compareSubtotal || 0
    ].join('|');

    if (bundleComponents) {
      props._BundleComponents = bundleComponents;
    }

    if (tracking.referralCode) {
      props._BundleReferralCode = tracking.referralCode;
    }

    if (tracking.discountPercent > 0) {
      props._BundleDiscountPercent = String(tracking.discountPercent);
    }

    return props;
  }

  async function handleAddToCart(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    if (selectedVariantIds.length < minProducts) return;

    const parentVariantId = config.parentVariantId ? parseInt(config.parentVariantId, 10) : null;
    if (!parentVariantId) {
      alert('Bundle parent product is missing. Add this section to a product page or set a parent product.');
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    setSparsetFeedbackState('loading');

    try {
      const bundleId = generateBundleId(config.bundleGroup || 'starter');
      const bundleTotals = getSelectionTotals();
      const discountPercent = bundleTotals.goalPercent || getDiscountPercent(bundleTotals.priceSubtotal);
      const referralCode = getActiveReferralCode();

      const itemQuantities = {};
      selectedVariantIds.forEach((variantId) => {
        const id = parseInt(variantId, 10);
        const step = getQuantityStep(variantId);
        itemQuantities[id] = (itemQuantities[id] || 0) + step;
      });

      const bundleComponents = buildBundleComponentsProperty(itemQuantities);

      const parentLineProps = bundleLineProperties(
        bundleId,
        parentVariantId,
        config.bundleTitle || 'Mein Sparset',
        bundleTotals,
        bundleComponents,
        { referralCode, discountPercent }
      );
      const childLineProps = {
        _BundleId: bundleId,
        _BundleRole: 'child'
      };

      if (parentVariantId) {
        childLineProps._BundleParentVariantId = String(parentVariantId);
      }

      if (config.parentHandle) {
        childLineProps._BundleParentHandle = String(config.parentHandle);
      }

      if (config.parentImage) {
        childLineProps._BundleParentImage = String(config.parentImage);
      }

      const items = [];

      Object.keys(itemQuantities).forEach((id) => {
        const variantId = parseInt(id, 10);
        if (variantId === parentVariantId) return;

        items.push({
          id: variantId,
          quantity: itemQuantities[id],
          properties: childLineProps
        });
      });

      if (!items.length) {
        throw new Error('No products selected');
      }

      items[0].properties = {
        ...items[0].properties,
        ...parentLineProps
      };

      const pfandItems = buildPfandCartItems(bundleId, itemQuantities);
      // Add Pfand in the same request first; ensureSparsetPfandInCart retries if FeeBee/cart drops them.
      pfandItems.forEach((pfandItem) => {
        items.push(pfandItem);
      });

      const nativeCartDrawer = document.querySelector('cart-drawer');
      const requestBody = { items };
      let sectionId = null;
      let sectionsParam = null;

      if (nativeCartDrawer) {
        const sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        sectionId = nativeCartDrawer.getAttribute('data-section-id') || 'cart-drawer';
        if (!sectionsToBundle.includes(sectionId)) {
          sectionsToBundle.push(sectionId);
        }
        sectionsParam = sectionsToBundle.join(',');
        requestBody.sections = sectionsParam;
      }

      let response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });

      let responseJson = {};

      if (!response.ok && pfandItems.length) {
        // Retry without Pfand if the combined add failed (e.g. FeeBee conflict), then attach Pfand separately.
        const bundleOnlyBody = {
          items: items.filter((item) => !item.properties?._SparsetPfandBundleId)
        };
        if (sectionsParam) bundleOnlyBody.sections = sectionsParam;

        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bundleOnlyBody)
        });
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Failed to add items to cart');
      }

      responseJson = await response.json();

      await updateCartTrackingAttributes(referralCode, discountPercent, {
        bundleId,
        bundleComponents,
        totals: {
          priceSubtotal: bundleTotals.priceSubtotal,
          discountedTotal: bundleTotals.discountedTotal,
          compareSubtotal: bundleTotals.compareSubtotal,
          discountPercent
        }
      });

      let cartContent = await ensureSparsetPfandInCart(bundleId, pfandItems, sectionsParam);
      if (!cartContent) {
        cartContent = await fetchCartJson();
      }

      if (nativeCartDrawer && sectionId && (!cartContent.sections || !cartContent.sections[sectionId])) {
        const cartDrawerResponse = await fetch(`${window.Shopify.routes.root}cart?section_id=${sectionId}`);
        const cartDrawerHtml = await cartDrawerResponse.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartDrawerHtml;
        const newCartDrawer = tempDiv.querySelector('#cart-drawer, cart-drawer');
        if (newCartDrawer) {
          if (!cartContent.sections) cartContent.sections = {};
          cartContent.sections[sectionId] = newCartDrawer.outerHTML;
        }
      }

      if (!cartContent.sections) cartContent.sections = {};
      cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

      setSparsetFeedbackState('success');
      await wait(1200);

      const productForm = document.querySelector('form[is="product-form"]');
      const formToUse = productForm || document.createElement('form');
      let formAdded = false;

      if (!productForm) {
        document.body.appendChild(formToUse);
        formAdded = true;
      }

      formToUse.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        cancelable: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart: cartContent
        }
      }));

      // Prevent orphan-cleanup from racing FeeBee transforms right after Sparset ATC.
      window.__sparsetPfandSyncQuietUntil = Date.now() + 5000;
      if (Array.isArray(window.__sparsetRecentPfandBundleIds)) {
        window.__sparsetRecentPfandBundleIds.push({ id: bundleId, until: Date.now() + 15000 });
      } else {
        window.__sparsetRecentPfandBundleIds = [{ id: bundleId, until: Date.now() + 15000 }];
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      }));

      if (formAdded) {
        document.body.removeChild(formToUse);
      }

      const shouldUseNativeCartDrawer = nativeCartDrawer
        && window.themeVariables?.settings?.cartType === 'drawer';

      if (!shouldUseNativeCartDrawer) {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        } else {
          window.dispatchEvent(new CustomEvent('rebuy:cart.open'));
        }
      }

      setSparsetFeedbackState(null);
    } catch (error) {
      console.error('Error adding sparset to cart:', error);
      setSparsetFeedbackState(null);
      alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = selectedVariantIds.length < minProducts;
    }
  }

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      adjustGoalNodePositions();
      updateUI();
    }, 150);
  };

  window.addEventListener('resize', onResize);

  function initMobileStickyVisibility() {
    const sectionEl = root.closest('.shopify-section--bk-media-sparset-builder') || root;
    const mobileMediaQuery = window.matchMedia('(max-width: 999px)');

    if (root._sparsetStickyObserver) {
      root._sparsetStickyObserver.disconnect();
      root._sparsetStickyObserver = null;
    }

    if (root._sparsetStickyResizeHandler) {
      mobileMediaQuery.removeEventListener('change', root._sparsetStickyResizeHandler);
      root._sparsetStickyResizeHandler = null;
    }

    const setStickyVisible = (isVisible) => {
      if (!mobileMediaQuery.matches) {
        root.classList.remove('is-sticky-visible');
        return;
      }

      root.classList.toggle('is-sticky-visible', isVisible);
    };

    root._sparsetStickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setStickyVisible(entry.isIntersecting);
      });
    }, { threshold: 0 });

    root._sparsetStickyObserver.observe(sectionEl);

    root._sparsetStickyResizeHandler = () => {
      if (!mobileMediaQuery.matches) {
        setStickyVisible(false);
        return;
      }

      const rect = sectionEl.getBoundingClientRect();
      setStickyVisible(rect.bottom > 0 && rect.top < window.innerHeight);
    };

    mobileMediaQuery.addEventListener('change', root._sparsetStickyResizeHandler);
    root._sparsetStickyResizeHandler();
  }

  initMobileStickyVisibility();

  const fallbackPreviewPercent = getPreviewDiscountFallbackPercent();
  resolvedPreviewDiscount = {
    type: fallbackPreviewPercent > 0 ? 'percentage' : null,
    value: fallbackPreviewPercent,
    code: null,
    loaded: true
  };

  initReferralCode();

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const isActive = button.getAttribute('aria-pressed') === 'true';
      if (isActive && button.getAttribute('data-filter-all') !== 'true') {
        const allButton = root.querySelector('[data-sparset-filter][data-filter-all="true"]');
        setActiveFilter(allButton || button);
        return;
      }
      setActiveFilter(button);
    });
  });

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      const isOpen = searchWrap?.classList.contains('is-open');
      setSearchOpen(!isOpen);
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', filterProductCards);
    searchInput.addEventListener('search', filterProductCards);
    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setSearchOpen(false);
        searchToggle?.focus();
      }
    });
  }

  requestAnimationFrame(() => {
    adjustGoalNodePositions();
    updateUI();
  });

  if ((config.previewDiscountCode || '').trim()) {
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  root._bkMediaSparsetInitialized = true;
}

function initAllBkMediaSparsetBuilders() {
  document.querySelectorAll('bk-media-sparset-builder').forEach(initBkMediaSparsetBuilder);
}

document.addEventListener('DOMContentLoaded', initAllBkMediaSparsetBuilders);
document.addEventListener('shopify:section:load', function (event) {
  setTimeout(function () {
    const builders = event.target ? event.target.querySelectorAll('bk-media-sparset-builder') : [];
    if (builders.length) {
      builders.forEach(function (root) {
        root._bkMediaSparsetInitialized = false;
        initBkMediaSparsetBuilder(root);
      });
      return;
    }
    initAllBkMediaSparsetBuilders();
  }, 100);
});

/* bk-media-sparset-builder end */

/* bk-media-bundle-cart-components start */

function initBkMediaBundleCartComponents() {
  document.querySelectorAll('.bk-media-line-item-components-disclosure').forEach((disclosure) => {
    disclosure.open = true;
    disclosure.setAttribute('aria-expanded', 'true');
  });
}

document.addEventListener('DOMContentLoaded', initBkMediaBundleCartComponents);
document.addEventListener('cart:change', () => {
  requestAnimationFrame(initBkMediaBundleCartComponents);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(initBkMediaBundleCartComponents, 100);
});

/* bk-media-bundle-cart-components end */

/* bk-media-rebuy-bundle-compare start */

function getCartItemProperties(item) {
  const props = {};

  if (!item || !item.properties) {
    return props;
  }

  if (Array.isArray(item.properties)) {
    item.properties.forEach((entry) => {
      const key = entry.name || entry.first || entry.key;
      const value = entry.value || entry.last;
      if (key) {
        props[key] = value;
      }
    });
    return props;
  }

  if (typeof item.properties === 'object') {
    return { ...item.properties };
  }

  return props;
}

function getBundleRole(props) {
  return props._BundleRole || props['Bundle role'] || '';
}

function isSparsetPfandLine(props) {
  if (!props) return false;
  if (props._PfandLocked === 'true' || props._PfandLocked === true) return true;
  if (getBundleRole(props) === 'pfand') return true;
  return Boolean(props._SparsetPfandBundleId);
}

function getSparsetPfandBundleId(props) {
  if (!props) return '';
  if (props._SparsetPfandBundleId) return String(props._SparsetPfandBundleId);
  // Legacy carts briefly stored the Sparset id on _BundleId for Pfand — only trust that
  // when the line is explicitly marked as pfand/locked, never for normal bundle lines.
  if (getBundleRole(props) === 'pfand' && props._BundleId) return String(props._BundleId);
  if ((props._PfandLocked === 'true' || props._PfandLocked === true) && props._BundleId && getBundleRole(props) !== 'parent') {
    return String(props._BundleId);
  }
  return '';
}

function isPfandEinheitCarrier(item) {
  const handle = String(item?.handle || item?.product_handle || '').toLowerCase();
  const title = String(item?.product_title || item?.title || '').toLowerCase();
  if (handle === 'pfand-einheit') return true;
  if (title.includes('pfand einheit')) return true;
  return false;
}

function getRecentSparsetPfandBundleIds() {
  const now = Date.now();
  const recent = Array.isArray(window.__sparsetRecentPfandBundleIds)
    ? window.__sparsetRecentPfandBundleIds.filter((entry) => entry && entry.until > now)
    : [];
  window.__sparsetRecentPfandBundleIds = recent;
  return new Set(recent.map((entry) => String(entry.id)));
}

function shouldRemoveOrphanSparsetPfand(item, props, activeBundleIds, recentBundleIds) {
  const isCarrier = isPfandEinheitCarrier(item);
  const isLinkedPfand = isSparsetPfandLine(props);
  if (!isCarrier && !isLinkedPfand) return false;

  const pfandBundleId = getSparsetPfandBundleId(props);

  if (!pfandBundleId && isCarrier && recentBundleIds.size > 0 && activeBundleIds.size > 0) {
    return false;
  }

  if (pfandBundleId && !activeBundleIds.has(pfandBundleId)) {
    return true;
  }

  // Only remove unlinked Pfand Einheit when NO Sparset parent remains.
  // (FeeBee often strips _SparsetPfandBundleId — never delete carriers while a Sparset exists.)
  if (!pfandBundleId && (isCarrier || isLinkedPfand) && activeBundleIds.size === 0 && recentBundleIds.size === 0) {
    return true;
  }

  return false;
}

let sparsetPfandSyncInFlight = false;

async function syncSparsetPfandWithCart(cart) {
  if (sparsetPfandSyncInFlight || !cart?.items) {
    return cart;
  }

  if (Date.now() < (window.__sparsetPfandSyncQuietUntil || 0)) {
    return cart;
  }

  const activeBundleIds = new Set();
  cart.items.forEach((item) => {
    const props = getCartItemProperties(item);
    const bundleId = props._BundleId;
    if (!bundleId) return;
    if (getBundleRole(props) === 'pfand' || isSparsetPfandLine(props) || isPfandEinheitCarrier(item)) return;
    activeBundleIds.add(String(bundleId));
  });

  const recentBundleIds = getRecentSparsetPfandBundleIds();

  const updates = {};
  cart.items.forEach((item) => {
    const props = getCartItemProperties(item);
    if (shouldRemoveOrphanSparsetPfand(item, props, activeBundleIds, recentBundleIds)) {
      updates[item.key] = 0;
    }
  });

  const updateKeys = Object.keys(updates);
  if (!updateKeys.length) {
    return cart;
  }

  sparsetPfandSyncInFlight = true;

  try {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    const cartDrawer = document.getElementById('cart-drawer');
    const sectionId = cartDrawer?.getAttribute('data-section-id') || 'cart-drawer';
    if (cartDrawer && !sectionsToBundle.includes(sectionId)) {
      sectionsToBundle.push(sectionId);
    }

    const body = { updates };
    if (sectionsToBundle.length) {
      body.sections = sectionsToBundle.join(',');
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      console.error('Failed to sync Sparset Pfand lines with cart');
      return cart;
    }

    const nextCart = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'sparset-pfand:sync',
        cart: nextCart
      }
    }));
    return nextCart;
  } catch (error) {
    console.error('Failed to sync Sparset Pfand lines with cart:', error);
    return cart;
  } finally {
    sparsetPfandSyncInFlight = false;
  }
}

function scheduleSparsetPfandCartSync(cart) {
  if (Date.now() < (window.__sparsetPfandSyncQuietUntil || 0)) {
    return;
  }

  const sourceCart = cart;
  Promise.resolve()
    .then(async () => {
      // Always re-fetch after a tick so FeeBee transforms / section updates settle first
      await new Promise((resolve) => setTimeout(resolve, 250));
      if (Date.now() < (window.__sparsetPfandSyncQuietUntil || 0)) {
        return null;
      }
      const cartToSync = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      return syncSparsetPfandWithCart(cartToSync);
    })
    .catch((error) => {
      console.error('Sparset Pfand cart sync failed:', error);
    });
}

function parseBundlePricing(props) {
  const raw = props._BundlePricing || props['Bundle pricing'];
  if (!raw || typeof raw !== 'string') {
    return null;
  }

  const parts = raw.split('|').map((value) => parseInt(value, 10));
  if (parts.length < 4 || parts.some((value) => Number.isNaN(value))) {
    return null;
  }

  return {
    compareTotal: parts[0],
    saleTotal: parts[1],
    discountPercent: parts[2],
    compareAtTotal: parts[3]
  };
}

function getBundleSaleCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const bundleId = props._BundleId;

  if (getBundleRole(props) === 'child') {
    return item.final_line_price || item.line_price || 0;
  }

  if (bundlePricing?.saleTotal > 0) {
    return bundlePricing.saleTotal;
  }

  let saleCents = item.final_line_price || item.line_price || 0;

  if (!bundleId || !Array.isArray(cartItems)) {
    return saleCents;
  }

  saleCents = cartItems.reduce((sum, line) => {
    const lineProps = getCartItemProperties(line);
    if (lineProps._BundleId !== bundleId) {
      return sum;
    }

    return sum + (line.final_line_price || line.line_price || 0);
  }, 0);

  const discountPercent = parseInt(props._BundleDiscountPercent, 10) || bundlePricing?.discountPercent || 0;
  const discountedTotal = parseInt(props._BundleDiscountedTotal, 10) || bundlePricing?.saleTotal || 0;

  if (discountPercent > 0 && discountedTotal > 0) {
    saleCents = discountedTotal;
  }

  return saleCents;
}

function getBundleCompareCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const saleCents = getBundleSaleCents(item, cartItems);
  const compareFromProps = parseInt(props._BundleCompareTotal, 10) || bundlePricing?.compareTotal || 0;

  if (compareFromProps > saleCents) {
    return compareFromProps;
  }

  const compareAtFromProps = parseInt(props._BundleCompareAtTotal, 10) || bundlePricing?.compareAtTotal || 0;
  if ((props._BundleShowVariantCompareAt === 'true' || compareAtFromProps > compareFromProps) && compareAtFromProps > saleCents) {
    return compareAtFromProps;
  }

  const finalCents = item.final_line_price || item.line_price || 0;

  if (item.original_line_price > saleCents) {
    return item.original_line_price;
  }

  if (item.variant?.compare_at_price > item.variant?.price) {
    const variantCompare = (item.variant.compare_at_price || 0) * (item.quantity || 1);
    if (variantCompare > saleCents) {
      return variantCompare;
    }
  }

  if (compareFromProps > finalCents) {
    return compareFromProps;
  }

  return 0;
}

function formatCartMoney(cents) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat);
  }

  return `${(cents / 100).toFixed(2)}`;
}

function refreshNativeCartDrawerBundlePrices() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) {
    return;
  }

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then((cart) => {
      if (!cart?.items?.length) {
        return;
      }

      cart.items.forEach((item) => {
        const props = getCartItemProperties(item);
        if (getBundleRole(props) === 'child' || isSparsetPfandLine(props) || isPfandEinheitCarrier(item)) {
          return;
        }

        const bundlePricing = parseBundlePricing(props);
        const bundleId = props._BundleId;
        if (!bundleId && !bundlePricing) {
          return;
        }

        const saleCents = getBundleSaleCents(item, cart.items);
        const compareCents = getBundleCompareCents(item, cart.items);
        if (!compareCents || compareCents <= saleCents) {
          return;
        }

        const lineItemEl = cartDrawer.querySelector(`line-item[data-line-key="${item.key}"]`);
        const priceList = lineItemEl?.querySelector('[data-bundle-price-list]') || lineItemEl?.querySelector('.k7-line-item-quantity-row price-list');
        if (!priceList) {
          return;
        }

        priceList.innerHTML = `<sale-price class="text-on-sale"><span class="sr-only">${window.themeVariables?.strings?.productPriceSale || 'Sale price'}</span>${formatCartMoney(saleCents)}</sale-price><compare-at-price class="text-subdued line-through"><span class="sr-only">${window.themeVariables?.strings?.productPriceRegular || 'Regular price'}</span>${formatCartMoney(compareCents)}</compare-at-price>`;
      });
    })
    .catch((error) => {
      console.error('Failed to refresh native cart drawer bundle prices:', error);
    });
}

function injectRebuyBundleComparePrices(cart) {
  if (!window.Rebuy || !cart?.items?.length) {
    return;
  }

  const flyout = document.querySelector('.rebuy-cart__flyout');
  if (!flyout) {
    return;
  }

  cart.items.forEach((item, index) => {
    const props = getCartItemProperties(item);
    if (getBundleRole(props) === 'child') {
      return;
    }

    const compareCents = getBundleCompareCents(item, cart.items);
    if (!compareCents) {
      return;
    }

    const saleCents = getBundleSaleCents(item, cart.items);
    const row = flyout.querySelector(`[data-rebuy-cart-item-index="${index}"]`) || flyout.querySelector(`[data-line-item-key="${item.key}"]`);
    const priceEl = row?.querySelector('.rebuy-cart__flyout-item-price, .rebuy-money');

    if (!priceEl || priceEl.dataset.bkBundleCompareApplied === 'true') {
      return;
    }

    priceEl.dataset.bkBundleCompareApplied = 'true';
    priceEl.innerHTML = `<span class="rebuy-money sale-price">${formatCartMoney(saleCents)}</span><span class="rebuy-money compare-at-price text-subdued line-through">${formatCartMoney(compareCents)}</span>`;
  });
}

async function refreshRebuyBundleComparePrices() {
  if (!window.Rebuy) {
    return;
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    requestAnimationFrame(() => injectRebuyBundleComparePrices(cart));
  } catch (error) {
    console.error('Failed to refresh Rebuy bundle compare prices:', error);
  }
}

document.addEventListener('DOMContentLoaded', refreshRebuyBundleComparePrices);
document.addEventListener('cart:change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:cart.change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:smartcart.show', refreshRebuyBundleComparePrices);

document.addEventListener('DOMContentLoaded', refreshNativeCartDrawerBundlePrices);
document.addEventListener('cart:change', () => {
  requestAnimationFrame(refreshNativeCartDrawerBundlePrices);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(refreshNativeCartDrawerBundlePrices, 100);
});

document.addEventListener('cart:change', (event) => {
  if (event?.detail?.baseEvent === 'sparset-pfand:sync') return;
  scheduleSparsetPfandCartSync(event?.detail?.cart);
});
document.addEventListener('line-item:change', (event) => {
  if (event?.detail?.quantity === 0) {
    scheduleSparsetPfandCartSync(event?.detail?.cart);
  }
});
document.addEventListener('rebuy:cart.change', () => {
  scheduleSparsetPfandCartSync();
});

// Clean leftover Pfand Einheit lines from earlier carts on every page load / drawer open
document.addEventListener('DOMContentLoaded', () => {
  scheduleSparsetPfandCartSync();
});
document.addEventListener('dialog:after-show', (event) => {
  if (event.target?.id === 'cart-drawer' || event.target?.tagName === 'CART-DRAWER') {
    scheduleSparsetPfandCartSync();
  }
});
document.addEventListener('rebuy:smartcart.show', () => {
  scheduleSparsetPfandCartSync();
});

/* bk-media-rebuy-bundle-compare end */

/* bk-media-product-gallery-bundle-placement start */

const BK_MEDIA_GALLERY_BUNDLE_DESKTOP_MQ = window.matchMedia('(min-width: 1000px)');

function findProductBundleSection(mainProductSection) {
  if (!mainProductSection) return null;

  var node = mainProductSection.nextElementSibling;

  while (node) {
    if (node.classList && node.classList.contains('shopify-section--bundle')) {
      return node;
    }
    node = node.nextElementSibling;
  }

  return document.querySelector('.shopify-section--bundle');
}

function refreshGalleryColumnSticky(slot) {
  var sticky = slot && slot.closest('safe-sticky.product-gallery-column');
  if (!sticky) return;

  function nudgeSticky() {
    sticky.style.removeProperty('top');
    window.dispatchEvent(new Event('scroll'));
  }

  requestAnimationFrame(nudgeSticky);
  setTimeout(nudgeSticky, 100);
  setTimeout(nudgeSticky, 500);
}

function toggleGalleryColumnBundleClasses(bundleSection, isActive) {
  if (!bundleSection) return;

  var bundleRoot = bundleSection.querySelector('.bk-media-bundle');

  if (isActive) {
    bundleSection.classList.add('is-in-gallery-column');
    if (bundleRoot) bundleRoot.classList.add('bk-media-bundle--in-gallery-column');
  } else {
    bundleSection.classList.remove('is-in-gallery-column');
    if (bundleRoot) bundleRoot.classList.remove('bk-media-bundle--in-gallery-column');
  }
}

function restoreProductGalleryBundleSection(state) {
  if (!state || !state.bundleSection || !state.originalParent) return;

  if (state.bundleSection.parentNode !== state.originalParent) {
    state.originalParent.insertBefore(state.bundleSection, state.originalNextSibling);
  }

  toggleGalleryColumnBundleClasses(state.bundleSection, false);
}

function placeProductGalleryBundleSection(slot, state, isDesktop) {
  if (!slot || !state || !state.bundleSection) return;

  if (isDesktop) {
    if (state.bundleSection.parentNode !== slot) {
      slot.appendChild(state.bundleSection);
    }
    toggleGalleryColumnBundleClasses(state.bundleSection, true);
    refreshGalleryColumnSticky(slot);
  } else {
    restoreProductGalleryBundleSection(state);
    refreshGalleryColumnSticky(slot);
  }
}

function initProductGalleryBundlePlacement(root) {
  var scope = root || document;
  var slots = scope.querySelectorAll('[data-product-gallery-bundle-slot][data-active]');

  slots.forEach(function(slot) {
    if (slot.dataset.bkMediaBundleSlotBound === 'true') {
      placeProductGalleryBundleSection(slot, slot._bkMediaBundleState, BK_MEDIA_GALLERY_BUNDLE_DESKTOP_MQ.matches);
      return;
    }

    slot.dataset.bkMediaBundleSlotBound = 'true';

    var mainProductSection = slot.closest('.shopify-section--main-product');
    var bundleSection = findProductBundleSection(mainProductSection);

    if (!bundleSection) return;

    slot._bkMediaBundleState = {
      bundleSection: bundleSection,
      originalParent: bundleSection.parentNode,
      originalNextSibling: bundleSection.nextSibling
    };

    placeProductGalleryBundleSection(slot, slot._bkMediaBundleState, BK_MEDIA_GALLERY_BUNDLE_DESKTOP_MQ.matches);

    if (!window.__bkMediaGalleryBundleMqListener) {
      window.__bkMediaGalleryBundleMqListener = true;
      BK_MEDIA_GALLERY_BUNDLE_DESKTOP_MQ.addEventListener('change', function() {
        document.querySelectorAll('[data-product-gallery-bundle-slot][data-active]').forEach(function(activeSlot) {
          placeProductGalleryBundleSection(activeSlot, activeSlot._bkMediaBundleState, BK_MEDIA_GALLERY_BUNDLE_DESKTOP_MQ.matches);
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initProductGalleryBundlePlacement();
});

document.addEventListener('shopify:section:load', function() {
  initProductGalleryBundlePlacement();
});

document.addEventListener('shopify:section:unload', function(event) {
  var slot = event.target.querySelector('[data-product-gallery-bundle-slot][data-active]');
  if (slot && slot._bkMediaBundleState) {
    restoreProductGalleryBundleSection(slot._bkMediaBundleState);
  }
});

/* bk-media-product-gallery-bundle-placement end */

/* bk-media-header-mobile-frost start */

function updateBkMediaHeaderFrost() {
  var header = document.querySelector('store-header.header');
  if (!header || !header.hasAttribute('sticky')) return;

  var scrolled = window.scrollY > 20 || header.querySelectorAll('[open]').length > 0;
  header.classList.toggle('bk-media-header--scrolled', scrolled);
}

function initBkMediaHeaderFrost() {
  updateBkMediaHeaderFrost();
  if (window.__bkMediaHeaderFrostBound) return;
  window.__bkMediaHeaderFrostBound = true;
  window.addEventListener('scroll', updateBkMediaHeaderFrost, { passive: true });
  document.addEventListener('toggle', updateBkMediaHeaderFrost, true);
}

document.addEventListener('DOMContentLoaded', initBkMediaHeaderFrost);
document.addEventListener('shopify:section:load', function() {
  window.__bkMediaHeaderFrostBound = false;
  initBkMediaHeaderFrost();
});

/* bk-media-header-mobile-frost end */

/* bk-media-sorte-waehlen-scroll start */

function bkMediaEaseInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function bkMediaCenteredScrollY(element) {
  if (!element) return 0;

  var stickyOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
  var visibleHeight = Math.max(window.innerHeight - stickyOffset, 0);
  var elementTop = element.getBoundingClientRect().top + window.pageYOffset;
  var elementHeight = element.offsetHeight || 0;

  return Math.max(0, elementTop - stickyOffset - (visibleHeight - elementHeight) / 2);
}

function bkMediaSmoothScrollTo(element, duration) {
  if (!element) return;

  var startY = window.pageYOffset;
  var targetY = bkMediaCenteredScrollY(element);
  var distance = targetY - startY;
  var startTime = null;

  if (Math.abs(distance) < 2) return;

  function step(timestamp) {
    if (startTime === null) startTime = timestamp;
    var progress = Math.min((timestamp - startTime) / duration, 1);
    window.scrollTo(0, startY + distance * bkMediaEaseInOutCubic(progress));
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

function initSorteWaehlenScroll() {
  var shouldScroll = false;

  try {
    shouldScroll = sessionStorage.getItem('bk-media-scroll-to-switcher') === '1';
    if (shouldScroll) sessionStorage.removeItem('bk-media-scroll-to-switcher');
  } catch (error) {}

  if (!shouldScroll && window.location.hash !== '#bk-media-product-switcher') return;

  var target = document.querySelector('.bk-media-product-switcher') || document.getElementById('bk-media-product-switcher');
  if (!target) return;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.scrollTo(0, 0);

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    window.scrollTo(0, bkMediaCenteredScrollY(target));
    return;
  }

  requestAnimationFrame(function() {
    setTimeout(function() {
      bkMediaSmoothScrollTo(target, 700);
    }, 80);
  });
}

if (!window.__bkMediaSorteWaehlenBound) {
  window.__bkMediaSorteWaehlenBound = true;

  document.addEventListener('click', function(event) {
    var link = event.target.closest('.bk-media-sorte-wechseln a, [data-bk-media-scroll-to-switcher]');
    if (!link) return;

    try {
      sessionStorage.setItem('bk-media-scroll-to-switcher', '1');
    } catch (error) {}
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSorteWaehlenScroll, { once: true });
} else {
  initSorteWaehlenScroll();
}

document.addEventListener('shopify:section:load', initSorteWaehlenScroll);

/* bk-media-sorte-waehlen-scroll end */

if (!window.customElements.get('scroll-strip')) {
  window.customElements.define('scroll-strip', class extends HTMLElement {
    connectedCallback() {
      this._onPrev = this._scrollBy.bind(this, -1);
      this._onNext = this._scrollBy.bind(this, 1);
      this._onScroll = this._syncControls.bind(this);
      this.addEventListener('control:prev', this._onPrev);
      this.addEventListener('control:next', this._onNext);
      this.addEventListener('scroll', this._onScroll, { passive: true });
      this._resizeObserver = new ResizeObserver(this._syncControls.bind(this));
      this._resizeObserver.observe(this);
      this._syncControls();
    }

    disconnectedCallback() {
      this.removeEventListener('control:prev', this._onPrev);
      this.removeEventListener('control:next', this._onNext);
      this.removeEventListener('scroll', this._onScroll);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    _step() {
      var cards = this.querySelectorAll('.bk-media-product-switcher__card');
      if (cards.length < 2) return this.clientWidth;
      return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
    }

    _scrollBy(direction) {
      var rtl = document.dir === 'rtl';
      this.scrollBy({
        left: (rtl ? -direction : direction) * this._step(),
        behavior: 'smooth'
      });
    }

    _syncControls() {
      var maxScroll = this.scrollWidth - this.clientWidth;
      this.classList.toggle('is-scrollable', maxScroll > 1);
      var sl = Math.abs(this.scrollLeft);
      var atStart = sl <= 2;
      var atEnd = maxScroll <= 1 || sl >= maxScroll - 2;
      document.querySelectorAll('button[is="prev-button"][aria-controls="' + this.id + '"]').forEach(function(button) {
        button.disabled = atStart;
      });
      document.querySelectorAll('button[is="next-button"][aria-controls="' + this.id + '"]').forEach(function(button) {
        button.disabled = atEnd;
      });
    }
  });
}

/* bk-media-product-switcher-expand start */

function initProductSwitcherExpand(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var switchers = scope.querySelectorAll ? scope.querySelectorAll('.bk-media-product-switcher') : [];

  if (scope.classList && scope.classList.contains('bk-media-product-switcher')) {
    switchers = [scope];
  }

  switchers.forEach(function(switcher) {
    if (switcher.dataset.expandBound === 'true') return;
    switcher.dataset.expandBound = 'true';

    var moreButton = switcher.querySelector('[data-switcher-more]');
    var lessButton = switcher.querySelector('[data-switcher-less]');

    function setExpanded(expanded) {
      switcher.classList.toggle('is-expanded', expanded);
      if (moreButton) moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (moreButton) {
      moreButton.addEventListener('click', function() {
        setExpanded(true);
      });
    }

    if (lessButton) {
      lessButton.addEventListener('click', function() {
        setExpanded(false);
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initProductSwitcherExpand();
  }, { once: true });
} else {
  initProductSwitcherExpand();
}

document.addEventListener('shopify:section:load', function(event) {
  initProductSwitcherExpand(event.target);
});

/* bk-media-product-switcher-expand end */
